/* tslint:disable */
/* eslint-disable */
/**
 * SankeyArt
 * Turn financial statements into beautiful Sankey diagrams
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActiveProduct
 */
export interface ActiveProduct {
    /**
     * 
     * @type {Product}
     * @memberof ActiveProduct
     */
    'product': Product;
    /**
     * 
     * @type {ProductMetadata}
     * @memberof ActiveProduct
     */
    'metadata': ProductMetadata;
    /**
     * 
     * @type {Price}
     * @memberof ActiveProduct
     */
    'default_price': Price;
    /**
     * 
     * @type {Price}
     * @memberof ActiveProduct
     */
    'annual_price': Price;
    /**
     * 
     * @type {Price}
     * @memberof ActiveProduct
     */
    'monthly_price': Price;
}
/**
 * * `per_unit` - Per-unit * `tiered` - Tiered
 * @export
 * @enum {string}
 */

export const BillingSchemeEnum = {
    PER_UNIT: 'per_unit',
    TIERED: 'tiered'
} as const;

export type BillingSchemeEnum = typeof BillingSchemeEnum[keyof typeof BillingSchemeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const BlankEnum = {
    EMPTY: ''
} as const;

export type BlankEnum = typeof BlankEnum[keyof typeof BlankEnum];


/**
 * * `1` - S * `2` - M * `3` - L * `custom` - Custom size
 * @export
 * @enum {string}
 */

export const CanvasSizeEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    CUSTOM: 'custom'
} as const;

export type CanvasSizeEnum = typeof CanvasSizeEnum[keyof typeof CanvasSizeEnum];


/**
 * * `percent` - Percentage * `absolute` - Absolute
 * @export
 * @enum {string}
 */

export const ComparisonLineValueTypeEnum = {
    PERCENT: 'percent',
    ABSOLUTE: 'absolute'
} as const;

export type ComparisonLineValueTypeEnum = typeof ComparisonLineValueTypeEnum[keyof typeof ComparisonLineValueTypeEnum];


/**
 * 
 * @export
 * @interface ConvertPDFToPNGsErrorResponse
 */
export interface ConvertPDFToPNGsErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ConvertPDFToPNGsErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ConvertPDFToPNGsResponse
 */
export interface ConvertPDFToPNGsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ConvertPDFToPNGsResponse
     */
    'page_images': Array<string>;
}
/**
 * * `US` - United States * `AU` - Australia * `AT` - Austria * `BE` - Belgium * `BG` - Bulgaria * `CA` - Canada * `HR` - Croatia * `CY` - Cyprus * `CZ` - Czech Republic * `DK` - Denmark * `EE` - Estonia * `FI` - Finland * `FR` - France * `DE` - Germany * `GR` - Greece * `HU` - Hungary * `IE` - Ireland * `IL` - Israel * `IT` - Italy * `JP` - Japan * `LV` - Latvia * `LT` - Lithuania * `LU` - Luxembourg * `MT` - Malta * `NL` - Netherlands * `NZ` - New Zealand * `NO` - Norway * `PL` - Poland * `PT` - Portugal * `RO` - Romania * `SK` - Slovakia * `SI` - Slovenia * `SA` - Saudi Arabia * `SG` - Singapore * `ZA` - South Africa * `ES` - Spain * `SE` - Sweden * `CH` - Switzerland * `TR` - Türkiye * `AE` - United Arab Emirates * `GB` - United Kingdom * `ROW` - Other
 * @export
 * @enum {string}
 */

export const CountryEnum = {
    US: 'US',
    AU: 'AU',
    AT: 'AT',
    BE: 'BE',
    BG: 'BG',
    CA: 'CA',
    HR: 'HR',
    CY: 'CY',
    CZ: 'CZ',
    DK: 'DK',
    EE: 'EE',
    FI: 'FI',
    FR: 'FR',
    DE: 'DE',
    GR: 'GR',
    HU: 'HU',
    IE: 'IE',
    IL: 'IL',
    IT: 'IT',
    JP: 'JP',
    LV: 'LV',
    LT: 'LT',
    LU: 'LU',
    MT: 'MT',
    NL: 'NL',
    NZ: 'NZ',
    NO: 'NO',
    PL: 'PL',
    PT: 'PT',
    RO: 'RO',
    SK: 'SK',
    SI: 'SI',
    SA: 'SA',
    SG: 'SG',
    ZA: 'ZA',
    ES: 'ES',
    SE: 'SE',
    CH: 'CH',
    TR: 'TR',
    AE: 'AE',
    GB: 'GB',
    ROW: 'ROW'
} as const;

export type CountryEnum = typeof CountryEnum[keyof typeof CountryEnum];


/**
 * 
 * @export
 * @interface CreateCheckoutRequest
 */
export interface CreateCheckoutRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCheckoutRequest
     */
    'priceId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCheckoutRequest
     */
    'quantity'?: number;
}
/**
 * * `excel` - Excel add-in * `powerpoint` - Powerpoint add-in * `web` - Web app
 * @export
 * @enum {string}
 */

export const CreatedWithEnum = {
    EXCEL: 'excel',
    POWERPOINT: 'powerpoint',
    WEB: 'web'
} as const;

export type CreatedWithEnum = typeof CreatedWithEnum[keyof typeof CreatedWithEnum];


/**
 * Custom RegisterSerializer to validate the user does not exist in the DB yet.
 * @export
 * @interface CustomRegisterRequest
 */
export interface CustomRegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomRegisterRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomRegisterRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CustomRegisterRequest
     */
    'password1': string;
    /**
     * 
     * @type {string}
     * @memberof CustomRegisterRequest
     */
    'password2': string;
}
/**
 * Basic serializer to pass CustomUser details to the front end. Extend with any fields your app needs.
 * @export
 * @interface CustomUser
 */
export interface CustomUser {
    /**
     * 
     * @type {number}
     * @memberof CustomUser
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomUser
     */
    'subscribed_to_promotional_emails'?: boolean | null;
    /**
     * 
     * @type {Team}
     * @memberof CustomUser
     */
    'default_team'?: Team;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'avatar_url': string;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'date_joined': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomUser
     */
    'is_authenticated': boolean;
    /**
     * Designates whether the user can log into this admin site.
     * @type {boolean}
     * @memberof CustomUser
     */
    'is_staff': boolean;
    /**
     * Designates that this user has all permissions without explicitly assigning them.
     * @type {boolean}
     * @memberof CustomUser
     */
    'is_superuser': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomUser
     */
    'is_official_sankey_editor': boolean;
    /**
     * The platform this user last used SankeyArt on.  * `excel` - Excel add-in * `powerpoint` - PowerPoint add-in * `web` - Web app * `unknown` - Unknown
     * @type {LastInteractedViaEnum}
     * @memberof CustomUser
     */
    'last_interacted_via'?: LastInteractedViaEnum;
    /**
     * We handle two cases similar as if the user would have an active Stripe subscription:  1) Manually managed plans (free plan and custom enterprise plan; they use    DB flags and are not handled via Stripe) 2) Referrer of paid users (referrers can get file slots although they don\'t have a    subscription themselves)  Users that fall under these two cases have a right to similar features as users with a Stripe subscription such that they are handled as an active_subscription in the app.  This function overwrites the parent SubscriptionModelBase.has_active_subscription function.
     * @type {boolean}
     * @memberof CustomUser
     */
    'has_active_subscription': boolean;
    /**
     * Authenticated non-customers are allowed to create up to 5 diagrams into their deficit. This is to allow them to play with the app before subscribing. Saving diagrams is still not possible until they have a subscription. Customers are not allowed to go into deficit, but they can create as many Sankeys as their subscription allows.
     * @type {boolean}
     * @memberof CustomUser
     */
    'can_create_sankeys': boolean;
    /**
     * Authenticated users are allowed to update Sankeys as long as they haven\'t already exceeded their slot limit. This can happen when their subscription expires or is downgraded.
     * @type {boolean}
     * @memberof CustomUser
     */
    'can_update_sankeys': boolean;
    /**
     * Always allow Sankey deletion for authenticated users.
     * @type {boolean}
     * @memberof CustomUser
     */
    'can_delete_sankeys': boolean;
    /**
     * Total number of Sankey file slots currently available to the user. It\'s a sum of and subscription-based slots and extra credit lifetime slots given to the user.
     * @type {number}
     * @memberof CustomUser
     */
    'allowed_nr_of_sankeys': number;
    /**
     * Total number of Sankeys created and owned by the user.
     * @type {number}
     * @memberof CustomUser
     */
    'created_nr_of_sankeys': number;
    /**
     * A simple difference between allowed and created number of Sankeys.
     * @type {number}
     * @memberof CustomUser
     */
    'remaining_nr_of_sankeys': number;
    /**
     * Returns the list of Sankey IDs owned by the user.
     * @type {Array<number>}
     * @memberof CustomUser
     */
    'owned_sankeys_ids': Array<number>;
}
/**
 * Basic serializer to pass CustomUser details to the front end. Extend with any fields your app needs.
 * @export
 * @interface CustomUserRequest
 */
export interface CustomUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomUserRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUserRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomUserRequest
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomUserRequest
     */
    'subscribed_to_promotional_emails'?: boolean | null;
    /**
     * 
     * @type {TeamRequest}
     * @memberof CustomUserRequest
     */
    'default_team'?: TeamRequest;
    /**
     * The platform this user last used SankeyArt on.  * `excel` - Excel add-in * `powerpoint` - PowerPoint add-in * `web` - Web app * `unknown` - Unknown
     * @type {LastInteractedViaEnum}
     * @memberof CustomUserRequest
     */
    'last_interacted_via'?: LastInteractedViaEnum;
}
/**
 * * `excel` - Data comes from an Excel spreadsheet * `inline` - Data has been entered directly in the diagram editor UI
 * @export
 * @enum {string}
 */

export const DataOriginEnum = {
    EXCEL: 'excel',
    INLINE: 'inline'
} as const;

export type DataOriginEnum = typeof DataOriginEnum[keyof typeof DataOriginEnum];


/**
 * * `search` - Google search * `youtube` - YouTube * `reddit` - Reddit * `linkedin` - LinkedIn * `twitter` - Twitter / X * `recommended` - Recommended by a friend or colleague * `other` - Other
 * @export
 * @enum {string}
 */

export const DiscoveredUsThroughEnum = {
    SEARCH: 'search',
    YOUTUBE: 'youtube',
    REDDIT: 'reddit',
    LINKEDIN: 'linkedin',
    TWITTER: 'twitter',
    RECOMMENDED: 'recommended',
    OTHER: 'other'
} as const;

export type DiscoveredUsThroughEnum = typeof DiscoveredUsThroughEnum[keyof typeof DiscoveredUsThroughEnum];


/**
 * * `png` - PNG * `svg` - SVG
 * @export
 * @enum {string}
 */

export const DownloadImageFormatEnum = {
    PNG: 'png',
    SVG: 'svg'
} as const;

export type DownloadImageFormatEnum = typeof DownloadImageFormatEnum[keyof typeof DownloadImageFormatEnum];


/**
 * 
 * @export
 * @interface DownloadImageRequestRequest
 */
export interface DownloadImageRequestRequest {
    /**
     * 
     * @type {SankeyRequest}
     * @memberof DownloadImageRequestRequest
     */
    'sankey': SankeyRequest;
}
/**
 * * `1` - Low * `2` - Medium * `4` - High
 * @export
 * @enum {string}
 */

export const DownloadScalePngEnum = {
    _1: '1',
    _2: '2',
    _4: '4'
} as const;

export type DownloadScalePngEnum = typeof DownloadScalePngEnum[keyof typeof DownloadScalePngEnum];


/**
 * * `Inter` - Inter * `JetBrains Mono` - JetBrains Mono * `Lato` - Lato * `Merriweather` - Merriweather * `Montserrat` - Montserrat * `Nunito` - Nunito * `Open Sans` - Open Sans * `Poppins` - Poppins * `Roboto` - Roboto * `Source Code Pro` - Source Code Pro
 * @export
 * @enum {string}
 */

export const FontFamilyEnum = {
    INTER: 'Inter',
    JET_BRAINS_MONO: 'JetBrains Mono',
    LATO: 'Lato',
    MERRIWEATHER: 'Merriweather',
    MONTSERRAT: 'Montserrat',
    NUNITO: 'Nunito',
    OPEN_SANS: 'Open Sans',
    POPPINS: 'Poppins',
    ROBOTO: 'Roboto',
    SOURCE_CODE_PRO: 'Source Code Pro'
} as const;

export type FontFamilyEnum = typeof FontFamilyEnum[keyof typeof FontFamilyEnum];


/**
 * 
 * @export
 * @interface GenerateSankeyFromImagesTaskResponse
 */
export interface GenerateSankeyFromImagesTaskResponse {
    /**
     * 
     * @type {string}
     * @memberof GenerateSankeyFromImagesTaskResponse
     */
    'task_id': string;
}
/**
 * 
 * @export
 * @interface Invitation
 */
export interface Invitation {
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Invitation
     */
    'team': number;
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'email': string;
    /**
     * 
     * @type {RoleEnum}
     * @memberof Invitation
     */
    'role'?: RoleEnum;
    /**
     * 
     * @type {string}
     * @memberof Invitation
     */
    'invited_by': string;
    /**
     * 
     * @type {boolean}
     * @memberof Invitation
     */
    'is_accepted'?: boolean;
}


/**
 * 
 * @export
 * @interface InvitationRequest
 */
export interface InvitationRequest {
    /**
     * 
     * @type {number}
     * @memberof InvitationRequest
     */
    'team': number;
    /**
     * 
     * @type {string}
     * @memberof InvitationRequest
     */
    'email': string;
    /**
     * 
     * @type {RoleEnum}
     * @memberof InvitationRequest
     */
    'role'?: RoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof InvitationRequest
     */
    'is_accepted'?: boolean;
}


/**
 * * `before` - Before the node * `after` - After the node * `outside` - Outside (before node and then after node) * `inside` - Inside (after node and then before node)
 * @export
 * @enum {string}
 */

export const LabelPosEnum = {
    BEFORE: 'before',
    AFTER: 'after',
    OUTSIDE: 'outside',
    INSIDE: 'inside'
} as const;

export type LabelPosEnum = typeof LabelPosEnum[keyof typeof LabelPosEnum];


/**
 * * `excel` - Excel add-in * `powerpoint` - PowerPoint add-in * `web` - Web app * `unknown` - Unknown
 * @export
 * @enum {string}
 */

export const LastInteractedViaEnum = {
    EXCEL: 'excel',
    POWERPOINT: 'powerpoint',
    WEB: 'web',
    UNKNOWN: 'unknown'
} as const;

export type LastInteractedViaEnum = typeof LastInteractedViaEnum[keyof typeof LastInteractedViaEnum];


/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface Membership
 */
export interface Membership {
    /**
     * 
     * @type {number}
     * @memberof Membership
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Membership
     */
    'user_id': number;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    'display_name': string;
    /**
     * 
     * @type {RoleEnum}
     * @memberof Membership
     */
    'role': RoleEnum;
}


/**
 * 
 * @export
 * @interface MembershipRequest
 */
export interface MembershipRequest {
    /**
     * 
     * @type {RoleEnum}
     * @memberof MembershipRequest
     */
    'role': RoleEnum;
}


/**
 * * `all` - All * `0` - 0 * `1` - 1 * `2` - 2 * `3` - 3
 * @export
 * @enum {string}
 */

export const NrOfDecimalsEnum = {
    ALL: 'all',
    _0: '0',
    _1: '1',
    _2: '2',
    _3: '3'
} as const;

export type NrOfDecimalsEnum = typeof NrOfDecimalsEnum[keyof typeof NrOfDecimalsEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const NullEnum = {
    NULL: 'null'
} as const;

export type NullEnum = typeof NullEnum[keyof typeof NullEnum];


/**
 * 
 * @export
 * @interface PaginatedInvitationList
 */
export interface PaginatedInvitationList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedInvitationList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedInvitationList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedInvitationList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Invitation>}
     * @memberof PaginatedInvitationList
     */
    'results': Array<Invitation>;
}
/**
 * 
 * @export
 * @interface PaginatedTeamList
 */
export interface PaginatedTeamList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTeamList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTeamList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTeamList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Team>}
     * @memberof PaginatedTeamList
     */
    'results': Array<Team>;
}
/**
 * Basic serializer to pass CustomUser details to the front end. Extend with any fields your app needs.
 * @export
 * @interface PatchedCustomUserRequest
 */
export interface PatchedCustomUserRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUserRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUserRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCustomUserRequest
     */
    'subscribed_to_promotional_emails'?: boolean | null;
    /**
     * 
     * @type {TeamRequest}
     * @memberof PatchedCustomUserRequest
     */
    'default_team'?: TeamRequest;
    /**
     * The platform this user last used SankeyArt on.  * `excel` - Excel add-in * `powerpoint` - PowerPoint add-in * `web` - Web app * `unknown` - Unknown
     * @type {LastInteractedViaEnum}
     * @memberof PatchedCustomUserRequest
     */
    'last_interacted_via'?: LastInteractedViaEnum;
}
/**
 * 
 * @export
 * @interface PatchedInvitationRequest
 */
export interface PatchedInvitationRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedInvitationRequest
     */
    'team'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedInvitationRequest
     */
    'email'?: string;
    /**
     * 
     * @type {RoleEnum}
     * @memberof PatchedInvitationRequest
     */
    'role'?: RoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedInvitationRequest
     */
    'is_accepted'?: boolean;
}


/**
 * 
 * @export
 * @interface PatchedSankeyRequest
 */
export interface PatchedSankeyRequest {
    /**
     * Background color of the diagram.
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'background_color'?: string;
    /**
     * Canvas height in pixels.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'canvas_height'?: number;
    /**
     * The size of the canvas.  * `1` - S * `2` - M * `3` - L * `custom` - Custom size
     * @type {CanvasSizeEnum}
     * @memberof PatchedSankeyRequest
     */
    'canvas_size'?: CanvasSizeEnum;
    /**
     * Canvas width in pixels.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'canvas_width'?: number;
    /**
     * 
     * @type {PatchedSankeyRequestChart}
     * @memberof PatchedSankeyRequest
     */
    'chart'?: PatchedSankeyRequestChart;
    /**
     * Determines the order of the chart type Sankeys, lower numbers are listed first.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'chart_type_list_position'?: number;
    /**
     * Chart type name, used e.g. to describe the Sankey in the footer.
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'chart_type_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'comparison_line_prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'comparison_line_suffix'?: string | null;
    /**
     * Type of value for the third label line (e.g. percent or absolute difference)  * `percent` - Percentage * `absolute` - Absolute
     * @type {ComparisonLineValueTypeEnum}
     * @memberof PatchedSankeyRequest
     */
    'comparison_line_value_type'?: ComparisonLineValueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'created_at'?: string | null;
    /**
     * The environment where this diagram was first created.  * `excel` - Excel add-in * `powerpoint` - Powerpoint add-in * `web` - Web app
     * @type {CreatedWithEnum}
     * @memberof PatchedSankeyRequest
     */
    'created_with'?: CreatedWithEnum;
    /**
     * The custom diagram title.
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'custom_title'?: string;
    /**
     * The origin of the diagram data.  * `excel` - Data comes from an Excel spreadsheet * `inline` - Data has been entered directly in the diagram editor UI
     * @type {DataOriginEnum}
     * @memberof PatchedSankeyRequest
     */
    'data_origin'?: DataOriginEnum;
    /**
     * Description or link to the original source that the diagram data is based on.
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'data_source_notes'?: string | null;
    /**
     * 
     * @type {PatchedSankeyRequestDownloadImageFormat}
     * @memberof PatchedSankeyRequest
     */
    'download_image_format'?: PatchedSankeyRequestDownloadImageFormat | null;
    /**
     * 
     * @type {PatchedSankeyRequestDownloadScalePng}
     * @memberof PatchedSankeyRequest
     */
    'download_scale_png'?: PatchedSankeyRequestDownloadScalePng | null;
    /**
     * The income statement\'s fiscal year.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'fiscal_year'?: number;
    /**
     * Font family of the diagram.  * `Inter` - Inter * `JetBrains Mono` - JetBrains Mono * `Lato` - Lato * `Merriweather` - Merriweather * `Montserrat` - Montserrat * `Nunito` - Nunito * `Open Sans` - Open Sans * `Poppins` - Poppins * `Roboto` - Roboto * `Source Code Pro` - Source Code Pro
     * @type {FontFamilyEnum}
     * @memberof PatchedSankeyRequest
     */
    'font_family'?: FontFamilyEnum;
    /**
     * Label font size.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'font_size'?: number;
    /**
     * Whether the Sankey is listed as a chart type in the footer.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'is_listed_chart_type_in_footer'?: boolean;
    /**
     * Whether the diagram features as the main example that anonymous users will first get to see.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'is_main_example'?: boolean;
    /**
     * Whether the diagram is an official public SankeyArt diagram that is shown in the official list of public companies.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'is_official'?: boolean | null;
    /**
     * Whether the diagram is a template that users can copy to create quicker.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'is_template'?: boolean;
    /**
     * The code that will be interpreted by JavaScript to create the Sankey diagram.
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'js_input'?: string;
    /**
     * Positions of the node labels.  * `before` - Before the node * `after` - After the node * `outside` - Outside (before node and then after node) * `inside` - Inside (after node and then before node)
     * @type {LabelPosEnum}
     * @memberof PatchedSankeyRequest
     */
    'label_pos'?: LabelPosEnum;
    /**
     * Height of nodes.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'node_height'?: number;
    /**
     * Spacing between nodes.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'node_spacing'?: number;
    /**
     * Width of nodes.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'node_width'?: number | null;
    /**
     * 
     * @type {PatchedSankeyRequestNrOfDecimals}
     * @memberof PatchedSankeyRequest
     */
    'nr_of_decimals'?: PatchedSankeyRequestNrOfDecimals | null;
    /**
     * Difference between upvotes and downvotes.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'points'?: number | null;
    /**
     * The permission level of everyone on the internet for this diagram.  * `no-access` - No access * `view` - View
     * @type {PublicPermissionEnum}
     * @memberof PatchedSankeyRequest
     */
    'public_permission'?: PublicPermissionEnum;
    /**
     * Manual movements of sankey diagram nodes.
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'remembered_node_moves'?: string | null;
    /**
     * The income statement\'s reporting period.  * `january` - January * `february` - February * `march` - March * `april` - April * `may` - May * `june` - June * `july` - July * `august` - August * `september` - September * `october` - October * `november` - November * `december` - December * `Q1` - Q1 * `Q2` - Q2 * `Q3` - Q3 * `Q4` - Q4 * `H1` - H1 * `H2` - H2 * `full_year` - Full Year
     * @type {ReportingPeriodEnum}
     * @memberof PatchedSankeyRequest
     */
    'reporting_period'?: ReportingPeriodEnum;
    /**
     * Type of value for the second label line (e.g. amount or percentage)  * `amount` - Absolute * `percent-neighbor` - % of neighbor * `percent-highest` - % of highest amount
     * @type {SecondLabelLineValueTypeEnum}
     * @memberof PatchedSankeyRequest
     */
    'second_label_line_value_type'?: SecondLabelLineValueTypeEnum;
    /**
     * Whether the diagram canvas resolution is shown in the UI.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'show_canvas_resolution'?: boolean | null;
    /**
     * Wheter the Sankey diagram should show a comparison in node labels.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'show_comparison_line'?: boolean | null;
    /**
     * Whether data editor table is shown in the UI.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'show_data_editor'?: boolean | null;
    /**
     * Wheter imbalances of nodes are shown in the UI.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'show_imbalances'?: boolean | null;
    /**
     * Wheter the Sankey diagram should include node labels.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'show_labels'?: boolean | null;
    /**
     * Wheter the Sankey diagram should show its title (e.g. \'Apple 2022 Q4\').
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'show_title'?: boolean | null;
    /**
     * Wheter the Sankey diagram should include a SankeyArt watermark.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'show_watermark'?: boolean | null;
    /**
     * 
     * @type {PatchedSankeyRequestStatementType}
     * @memberof PatchedSankeyRequest
     */
    'statement_type'?: PatchedSankeyRequestStatementType | null;
    /**
     * The SVG representation of this Sankey diagram.
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'svg_representation'?: string | null;
    /**
     * The permission level of non-owner team members for this diagram.  * `no-access` - No access * `view` - View * `edit` - Edit
     * @type {TeamPermissionEnum}
     * @memberof PatchedSankeyRequest
     */
    'team_permission'?: TeamPermissionEnum;
    /**
     * Title font color.
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'title_font_color'?: string | null;
    /**
     * Title font size.
     * @type {number}
     * @memberof PatchedSankeyRequest
     */
    'title_font_size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'unit_prefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedSankeyRequest
     */
    'unit_suffix'?: string | null;
    /**
     * Wheter a custom (not automatically generated) diagram title is used.
     * @type {boolean}
     * @memberof PatchedSankeyRequest
     */
    'use_custom_title'?: boolean | null;
}
/**
 * @type PatchedSankeyRequestChart
 * @export
 */
export type PatchedSankeyRequestChart = SankeyArtChartSchemaSankeyV1;

/**
 * @type PatchedSankeyRequestDownloadImageFormat
 * The last selected format of the downloaded image.  * `png` - PNG * `svg` - SVG
 * @export
 */
export type PatchedSankeyRequestDownloadImageFormat = DownloadImageFormatEnum | NullEnum;

/**
 * @type PatchedSankeyRequestDownloadScalePng
 * Scales the resolution of the download PNG file.  * `1` - Low * `2` - Medium * `4` - High
 * @export
 */
export type PatchedSankeyRequestDownloadScalePng = DownloadScalePngEnum | NullEnum;

/**
 * @type PatchedSankeyRequestNrOfDecimals
 * Number of decimals to show in labels  * `all` - All * `0` - 0 * `1` - 1 * `2` - 2 * `3` - 3
 * @export
 */
export type PatchedSankeyRequestNrOfDecimals = NrOfDecimalsEnum | NullEnum;

/**
 * @type PatchedSankeyRequestStatementType
 * The type of the financial statement.  * `income` - Income statement * `cashflow` - Cash flow statement * `balance` - Balance sheet * `budget` - Budget * `other` - Other
 * @export
 */
export type PatchedSankeyRequestStatementType = NullEnum | StatementTypeEnum;

/**
 * 
 * @export
 * @interface PatchedTeamRequest
 */
export interface PatchedTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedTeamRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTeamRequest
     */
    'slug'?: string;
    /**
     * 
     * @type {PatchedTeamRequestCountry}
     * @memberof PatchedTeamRequest
     */
    'country'?: PatchedTeamRequestCountry;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedTeamRequest
     */
    'is_b2b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedTeamRequest
     */
    'has_user_completed_team_info'?: boolean;
    /**
     * The platform this team first signed up through  * `excel` - Excel add-in * `powerpoint` - PowerPoint add-in * `web` - Web app * `unknown` - Unknown
     * @type {SignedUpViaEnum}
     * @memberof PatchedTeamRequest
     */
    'signed_up_via'?: SignedUpViaEnum;
    /**
     * 
     * @type {PatchedTeamRequestDiscoveredUsThrough}
     * @memberof PatchedTeamRequest
     */
    'discovered_us_through'?: PatchedTeamRequestDiscoveredUsThrough;
    /**
     * A freetext for how the team discovered SankeyArt if its none of the given options.
     * @type {string}
     * @memberof PatchedTeamRequest
     */
    'discovered_us_note'?: string;
    /**
     * Used to store team-specific settings
     * @type {{ [key: string]: any; }}
     * @memberof PatchedTeamRequest
     */
    'settings'?: { [key: string]: any; };
}
/**
 * @type PatchedTeamRequestCountry
 * @export
 */
export type PatchedTeamRequestCountry = BlankEnum | CountryEnum;

/**
 * @type PatchedTeamRequestDiscoveredUsThrough
 * How the team discovered SankeyArt  * `search` - Google search * `youtube` - YouTube * `reddit` - Reddit * `linkedin` - LinkedIn * `twitter` - Twitter / X * `recommended` - Recommended by a friend or colleague * `other` - Other
 * @export
 */
export type PatchedTeamRequestDiscoveredUsThrough = BlankEnum | DiscoveredUsThroughEnum;

/**
 * 
 * @export
 * @interface Price
 */
export interface Price {
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof Price
     */
    'human_readable_price': string;
    /**
     * A brief description of the plan, hidden from customers.
     * @type {string}
     * @memberof Price
     */
    'nickname'?: string;
    /**
     * The unit amount in cents to be charged, represented as a whole integer if possible. Null if a sub-cent precision is required.
     * @type {number}
     * @memberof Price
     */
    'unit_amount'?: number | null;
    /**
     * 
     * @type {PriceBillingScheme}
     * @memberof Price
     */
    'billing_scheme'?: PriceBillingScheme;
    /**
     * 
     * @type {Array<Tier>}
     * @memberof Price
     */
    'tiers'?: Array<Tier>;
    /**
     * 
     * @type {PriceTiersMode}
     * @memberof Price
     */
    'tiers_mode'?: PriceTiersMode | null;
}
/**
 * @type PriceBillingScheme
 * Describes how to compute the price per period. Either `per_unit` or `tiered`. `per_unit` indicates that the fixed amount (specified in `unit_amount` or `unit_amount_decimal`) will be charged per unit in `quantity` (for prices with `usage_type=licensed`), or per unit of total usage (for prices with `usage_type=metered`). `tiered` indicates that the unit pricing will be computed using a tiering strategy as defined using the `tiers` and `tiers_mode` attributes.  * `per_unit` - Per-unit * `tiered` - Tiered
 * @export
 */
export type PriceBillingScheme = BillingSchemeEnum | BlankEnum;

/**
 * 
 * @export
 * @interface PriceRequest
 */
export interface PriceRequest {
    /**
     * 
     * @type {string}
     * @memberof PriceRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PriceRequest
     */
    'product_name': string;
    /**
     * A brief description of the plan, hidden from customers.
     * @type {string}
     * @memberof PriceRequest
     */
    'nickname'?: string;
    /**
     * The unit amount in cents to be charged, represented as a whole integer if possible. Null if a sub-cent precision is required.
     * @type {number}
     * @memberof PriceRequest
     */
    'unit_amount'?: number | null;
    /**
     * 
     * @type {PriceBillingScheme}
     * @memberof PriceRequest
     */
    'billing_scheme'?: PriceBillingScheme;
    /**
     * 
     * @type {Array<TierRequest>}
     * @memberof PriceRequest
     */
    'tiers'?: Array<TierRequest>;
    /**
     * 
     * @type {PriceTiersMode}
     * @memberof PriceRequest
     */
    'tiers_mode'?: PriceTiersMode | null;
}
/**
 * @type PriceTiersMode
 * Defines if the tiering price should be `graduated` or `volume` based. In `volume`-based tiering, the maximum quantity within a period determines the per unit price, in `graduated` tiering pricing can successively change as the quantity grows.  * `graduated` - Graduated * `volume` - Volume-based
 * @export
 */
export type PriceTiersMode = BlankEnum | NullEnum | TiersModeEnum;

/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'id': string;
    /**
     * The product\'s name, meant to be displayable to the customer. Applicable to both `service` and `good` types.
     * @type {string}
     * @memberof Product
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ProductMetadata
 */
export interface ProductMetadata {
    /**
     * 
     * @type {string}
     * @memberof ProductMetadata
     */
    'stripe_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductMetadata
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof ProductMetadata
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductMetadata
     */
    'excluded_features': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductMetadata
     */
    'features': Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ProductMetadata
     */
    'price_displays': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ProductMetadata
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductMetadata
     */
    'is_default': boolean;
}
/**
 * * `no-access` - No access * `view` - View
 * @export
 * @enum {string}
 */

export const PublicPermissionEnum = {
    NO_ACCESS: 'no-access',
    VIEW: 'view'
} as const;

export type PublicPermissionEnum = typeof PublicPermissionEnum[keyof typeof PublicPermissionEnum];


/**
 * * `january` - January * `february` - February * `march` - March * `april` - April * `may` - May * `june` - June * `july` - July * `august` - August * `september` - September * `october` - October * `november` - November * `december` - December * `Q1` - Q1 * `Q2` - Q2 * `Q3` - Q3 * `Q4` - Q4 * `H1` - H1 * `H2` - H2 * `full_year` - Full Year
 * @export
 * @enum {string}
 */

export const ReportingPeriodEnum = {
    JANUARY: 'january',
    FEBRUARY: 'february',
    MARCH: 'march',
    APRIL: 'april',
    MAY: 'may',
    JUNE: 'june',
    JULY: 'july',
    AUGUST: 'august',
    SEPTEMBER: 'september',
    OCTOBER: 'october',
    NOVEMBER: 'november',
    DECEMBER: 'december',
    Q1: 'Q1',
    Q2: 'Q2',
    Q3: 'Q3',
    Q4: 'Q4',
    H1: 'H1',
    H2: 'H2',
    FULL_YEAR: 'full_year'
} as const;

export type ReportingPeriodEnum = typeof ReportingPeriodEnum[keyof typeof ReportingPeriodEnum];


/**
 * 
 * @export
 * @interface RestAuthDetail
 */
export interface RestAuthDetail {
    /**
     * 
     * @type {string}
     * @memberof RestAuthDetail
     */
    'detail': string;
}
/**
 * * `admin` - Administrator * `editor` - Editor
 * @export
 * @enum {string}
 */

export const RoleEnum = {
    ADMIN: 'admin',
    EDITOR: 'editor'
} as const;

export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];


/**
 * 
 * @export
 * @interface Sankey
 */
export interface Sankey {
    /**
     * Background color of the diagram.
     * @type {string}
     * @memberof Sankey
     */
    'background_color'?: string;
    /**
     * Canvas height in pixels.
     * @type {number}
     * @memberof Sankey
     */
    'canvas_height'?: number;
    /**
     * The size of the canvas.  * `1` - S * `2` - M * `3` - L * `custom` - Custom size
     * @type {CanvasSizeEnum}
     * @memberof Sankey
     */
    'canvas_size'?: CanvasSizeEnum;
    /**
     * Canvas width in pixels.
     * @type {number}
     * @memberof Sankey
     */
    'canvas_width'?: number;
    /**
     * 
     * @type {PatchedSankeyRequestChart}
     * @memberof Sankey
     */
    'chart'?: PatchedSankeyRequestChart;
    /**
     * Determines the order of the chart type Sankeys, lower numbers are listed first.
     * @type {number}
     * @memberof Sankey
     */
    'chart_type_list_position'?: number;
    /**
     * Chart type name, used e.g. to describe the Sankey in the footer.
     * @type {string}
     * @memberof Sankey
     */
    'chart_type_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Sankey
     */
    'company_name': string;
    /**
     * 
     * @type {string}
     * @memberof Sankey
     */
    'comparison_line_prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof Sankey
     */
    'comparison_line_suffix'?: string | null;
    /**
     * Type of value for the third label line (e.g. percent or absolute difference)  * `percent` - Percentage * `absolute` - Absolute
     * @type {ComparisonLineValueTypeEnum}
     * @memberof Sankey
     */
    'comparison_line_value_type'?: ComparisonLineValueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Sankey
     */
    'created_at'?: string | null;
    /**
     * The environment where this diagram was first created.  * `excel` - Excel add-in * `powerpoint` - Powerpoint add-in * `web` - Web app
     * @type {CreatedWithEnum}
     * @memberof Sankey
     */
    'created_with'?: CreatedWithEnum;
    /**
     * The custom diagram title.
     * @type {string}
     * @memberof Sankey
     */
    'custom_title'?: string;
    /**
     * The origin of the diagram data.  * `excel` - Data comes from an Excel spreadsheet * `inline` - Data has been entered directly in the diagram editor UI
     * @type {DataOriginEnum}
     * @memberof Sankey
     */
    'data_origin'?: DataOriginEnum;
    /**
     * Description or link to the original source that the diagram data is based on.
     * @type {string}
     * @memberof Sankey
     */
    'data_source_notes'?: string | null;
    /**
     * 
     * @type {PatchedSankeyRequestDownloadImageFormat}
     * @memberof Sankey
     */
    'download_image_format'?: PatchedSankeyRequestDownloadImageFormat | null;
    /**
     * 
     * @type {PatchedSankeyRequestDownloadScalePng}
     * @memberof Sankey
     */
    'download_scale_png'?: PatchedSankeyRequestDownloadScalePng | null;
    /**
     * The income statement\'s fiscal year.
     * @type {number}
     * @memberof Sankey
     */
    'fiscal_year': number;
    /**
     * Font family of the diagram.  * `Inter` - Inter * `JetBrains Mono` - JetBrains Mono * `Lato` - Lato * `Merriweather` - Merriweather * `Montserrat` - Montserrat * `Nunito` - Nunito * `Open Sans` - Open Sans * `Poppins` - Poppins * `Roboto` - Roboto * `Source Code Pro` - Source Code Pro
     * @type {FontFamilyEnum}
     * @memberof Sankey
     */
    'font_family'?: FontFamilyEnum;
    /**
     * Label font size.
     * @type {number}
     * @memberof Sankey
     */
    'font_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof Sankey
     */
    'id': number;
    /**
     * Whether the Sankey is listed as a chart type in the footer.
     * @type {boolean}
     * @memberof Sankey
     */
    'is_listed_chart_type_in_footer'?: boolean;
    /**
     * Whether the diagram features as the main example that anonymous users will first get to see.
     * @type {boolean}
     * @memberof Sankey
     */
    'is_main_example'?: boolean;
    /**
     * Whether the diagram is an official public SankeyArt diagram that is shown in the official list of public companies.
     * @type {boolean}
     * @memberof Sankey
     */
    'is_official'?: boolean | null;
    /**
     * Whether the diagram is a template that users can copy to create quicker.
     * @type {boolean}
     * @memberof Sankey
     */
    'is_template'?: boolean;
    /**
     * The code that will be interpreted by JavaScript to create the Sankey diagram.
     * @type {string}
     * @memberof Sankey
     */
    'js_input'?: string;
    /**
     * Positions of the node labels.  * `before` - Before the node * `after` - After the node * `outside` - Outside (before node and then after node) * `inside` - Inside (after node and then before node)
     * @type {LabelPosEnum}
     * @memberof Sankey
     */
    'label_pos'?: LabelPosEnum;
    /**
     * Height of nodes.
     * @type {number}
     * @memberof Sankey
     */
    'node_height'?: number;
    /**
     * Spacing between nodes.
     * @type {number}
     * @memberof Sankey
     */
    'node_spacing'?: number;
    /**
     * Width of nodes.
     * @type {number}
     * @memberof Sankey
     */
    'node_width'?: number | null;
    /**
     * 
     * @type {PatchedSankeyRequestNrOfDecimals}
     * @memberof Sankey
     */
    'nr_of_decimals'?: PatchedSankeyRequestNrOfDecimals | null;
    /**
     * 
     * @type {number}
     * @memberof Sankey
     */
    'owner_id': number;
    /**
     * Difference between upvotes and downvotes.
     * @type {number}
     * @memberof Sankey
     */
    'points'?: number | null;
    /**
     * The permission level of everyone on the internet for this diagram.  * `no-access` - No access * `view` - View
     * @type {PublicPermissionEnum}
     * @memberof Sankey
     */
    'public_permission'?: PublicPermissionEnum;
    /**
     * Manual movements of sankey diagram nodes.
     * @type {string}
     * @memberof Sankey
     */
    'remembered_node_moves'?: string | null;
    /**
     * The income statement\'s reporting period.  * `january` - January * `february` - February * `march` - March * `april` - April * `may` - May * `june` - June * `july` - July * `august` - August * `september` - September * `october` - October * `november` - November * `december` - December * `Q1` - Q1 * `Q2` - Q2 * `Q3` - Q3 * `Q4` - Q4 * `H1` - H1 * `H2` - H2 * `full_year` - Full Year
     * @type {ReportingPeriodEnum}
     * @memberof Sankey
     */
    'reporting_period': ReportingPeriodEnum;
    /**
     * Type of value for the second label line (e.g. amount or percentage)  * `amount` - Absolute * `percent-neighbor` - % of neighbor * `percent-highest` - % of highest amount
     * @type {SecondLabelLineValueTypeEnum}
     * @memberof Sankey
     */
    'second_label_line_value_type'?: SecondLabelLineValueTypeEnum;
    /**
     * Whether the diagram canvas resolution is shown in the UI.
     * @type {boolean}
     * @memberof Sankey
     */
    'show_canvas_resolution'?: boolean | null;
    /**
     * Wheter the Sankey diagram should show a comparison in node labels.
     * @type {boolean}
     * @memberof Sankey
     */
    'show_comparison_line'?: boolean | null;
    /**
     * Whether data editor table is shown in the UI.
     * @type {boolean}
     * @memberof Sankey
     */
    'show_data_editor'?: boolean | null;
    /**
     * Wheter imbalances of nodes are shown in the UI.
     * @type {boolean}
     * @memberof Sankey
     */
    'show_imbalances'?: boolean | null;
    /**
     * Wheter the Sankey diagram should include node labels.
     * @type {boolean}
     * @memberof Sankey
     */
    'show_labels'?: boolean | null;
    /**
     * Wheter the Sankey diagram should show its title (e.g. \'Apple 2022 Q4\').
     * @type {boolean}
     * @memberof Sankey
     */
    'show_title'?: boolean | null;
    /**
     * Wheter the Sankey diagram should include a SankeyArt watermark.
     * @type {boolean}
     * @memberof Sankey
     */
    'show_watermark'?: boolean | null;
    /**
     * 
     * @type {PatchedSankeyRequestStatementType}
     * @memberof Sankey
     */
    'statement_type'?: PatchedSankeyRequestStatementType | null;
    /**
     * The SVG representation of this Sankey diagram.
     * @type {string}
     * @memberof Sankey
     */
    'svg_representation'?: string | null;
    /**
     * The permission level of non-owner team members for this diagram.  * `no-access` - No access * `view` - View * `edit` - Edit
     * @type {TeamPermissionEnum}
     * @memberof Sankey
     */
    'team_permission'?: TeamPermissionEnum;
    /**
     * Title font color.
     * @type {string}
     * @memberof Sankey
     */
    'title_font_color'?: string | null;
    /**
     * Title font size.
     * @type {number}
     * @memberof Sankey
     */
    'title_font_size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Sankey
     */
    'unit_prefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Sankey
     */
    'unit_suffix'?: string | null;
    /**
     * Wheter a custom (not automatically generated) diagram title is used.
     * @type {boolean}
     * @memberof Sankey
     */
    'use_custom_title'?: boolean | null;
}
/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1
 */
export interface SankeyArtChartSchemaSankeyV1 {
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1
     */
    'type': SankeyArtChartSchemaSankeyV1TypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1
     */
    'version': SankeyArtChartSchemaSankeyV1VersionEnum;
    /**
     * 
     * @type {SankeyArtChartSchemaSankeyV1Settings}
     * @memberof SankeyArtChartSchemaSankeyV1
     */
    'settings': SankeyArtChartSchemaSankeyV1Settings;
    /**
     * 
     * @type {SankeyArtChartSchemaSankeyV1Title}
     * @memberof SankeyArtChartSchemaSankeyV1
     */
    'title': SankeyArtChartSchemaSankeyV1Title;
    /**
     * 
     * @type {SankeyArtChartSchemaSankeyV1Data}
     * @memberof SankeyArtChartSchemaSankeyV1
     */
    'data': SankeyArtChartSchemaSankeyV1Data;
}

export const SankeyArtChartSchemaSankeyV1TypeEnum = {
    SANKEY: 'sankey'
} as const;

export type SankeyArtChartSchemaSankeyV1TypeEnum = typeof SankeyArtChartSchemaSankeyV1TypeEnum[keyof typeof SankeyArtChartSchemaSankeyV1TypeEnum];
export const SankeyArtChartSchemaSankeyV1VersionEnum = {
    NUMBER_1: 1
} as const;

export type SankeyArtChartSchemaSankeyV1VersionEnum = typeof SankeyArtChartSchemaSankeyV1VersionEnum[keyof typeof SankeyArtChartSchemaSankeyV1VersionEnum];

/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1Data
 */
export interface SankeyArtChartSchemaSankeyV1Data {
    /**
     * 
     * @type {Array<SankeyArtChartSchemaSankeyV1DataNodesInner>}
     * @memberof SankeyArtChartSchemaSankeyV1Data
     */
    'nodes': Array<SankeyArtChartSchemaSankeyV1DataNodesInner>;
    /**
     * 
     * @type {Array<SankeyArtChartSchemaSankeyV1DataFlowsInner>}
     * @memberof SankeyArtChartSchemaSankeyV1Data
     */
    'flows': Array<SankeyArtChartSchemaSankeyV1DataFlowsInner>;
}
/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1DataFlowsInner
 */
export interface SankeyArtChartSchemaSankeyV1DataFlowsInner {
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataFlowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataFlowsInner
     */
    'color': string;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1DataFlowsInner
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1DataFlowsInner
     */
    'value_comparison'?: number;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataFlowsInner
     */
    'source_node_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataFlowsInner
     */
    'target_node_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1DataFlowsInner
     */
    'data_grid_row_index': number;
}
/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1DataNodesInner
 */
export interface SankeyArtChartSchemaSankeyV1DataNodesInner {
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInner
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInner
     */
    'id': string;
    /**
     * 
     * @type {SankeyArtChartSchemaSankeyV1DataNodesInnerLabelColor}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInner
     */
    'label_color': SankeyArtChartSchemaSankeyV1DataNodesInnerLabelColor;
    /**
     * 
     * @type {SankeyArtChartSchemaSankeyV1DataNodesInnerLabelComparisonValue}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInner
     */
    'label_comparison_value': SankeyArtChartSchemaSankeyV1DataNodesInnerLabelComparisonValue;
    /**
     * 
     * @type {SankeyArtChartSchemaSankeyV1DataNodesInnerLabelComparisonValue}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInner
     */
    'label_value': SankeyArtChartSchemaSankeyV1DataNodesInnerLabelComparisonValue;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInner
     */
    'name': string;
    /**
     * 
     * @type {SankeyArtChartSchemaSankeyV1DataNodesInnerOffset}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInner
     */
    'offset': SankeyArtChartSchemaSankeyV1DataNodesInnerOffset;
}
/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1DataNodesInnerLabelColor
 */
export interface SankeyArtChartSchemaSankeyV1DataNodesInnerLabelColor {
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInnerLabelColor
     */
    'custom': string;
    /**
     * 
     * @type {boolean}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInnerLabelColor
     */
    'use_custom': boolean;
}
/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1DataNodesInnerLabelComparisonValue
 */
export interface SankeyArtChartSchemaSankeyV1DataNodesInnerLabelComparisonValue {
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInnerLabelComparisonValue
     */
    'custom': string;
    /**
     * 
     * @type {boolean}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInnerLabelComparisonValue
     */
    'use_custom': boolean;
}
/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1DataNodesInnerOffset
 */
export interface SankeyArtChartSchemaSankeyV1DataNodesInnerOffset {
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInnerOffset
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1DataNodesInnerOffset
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1Settings
 */
export interface SankeyArtChartSchemaSankeyV1Settings {
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'background_color': string;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'font_family': SankeyArtChartSchemaSankeyV1SettingsFontFamilyEnum;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_comparison_value_prefix': string;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_comparison_value_suffix': string;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_comparison_value_type': SankeyArtChartSchemaSankeyV1SettingsLabelComparisonValueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_default_color': string;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_font_size': number;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_placement': SankeyArtChartSchemaSankeyV1SettingsLabelPlacementEnum;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_value_number_of_decimals': SankeyArtChartSchemaSankeyV1SettingsLabelValueNumberOfDecimalsEnum;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_value_prefix': string;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_value_suffix': string;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'label_value_type': SankeyArtChartSchemaSankeyV1SettingsLabelValueTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'node_width': number;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'node_height': number;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'node_spacing': number;
    /**
     * 
     * @type {boolean}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'show_comparison_value': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'show_imbalances': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'show_labels': boolean;
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Settings
     */
    'statement_type': SankeyArtChartSchemaSankeyV1SettingsStatementTypeEnum;
}

export const SankeyArtChartSchemaSankeyV1SettingsFontFamilyEnum = {
    INTER: 'Inter',
    JET_BRAINS_MONO: 'JetBrains Mono',
    LATO: 'Lato',
    MERRIWEATHER: 'Merriweather',
    MONTSERRAT: 'Montserrat',
    NUNITO: 'Nunito',
    OPEN_SANS: 'Open Sans',
    POPPINS: 'Poppins',
    ROBOTO: 'Roboto',
    SOURCE_CODE_PRO: 'Source Code Pro'
} as const;

export type SankeyArtChartSchemaSankeyV1SettingsFontFamilyEnum = typeof SankeyArtChartSchemaSankeyV1SettingsFontFamilyEnum[keyof typeof SankeyArtChartSchemaSankeyV1SettingsFontFamilyEnum];
export const SankeyArtChartSchemaSankeyV1SettingsLabelComparisonValueTypeEnum = {
    ABSOLUTE: 'absolute',
    PERCENT: 'percent'
} as const;

export type SankeyArtChartSchemaSankeyV1SettingsLabelComparisonValueTypeEnum = typeof SankeyArtChartSchemaSankeyV1SettingsLabelComparisonValueTypeEnum[keyof typeof SankeyArtChartSchemaSankeyV1SettingsLabelComparisonValueTypeEnum];
export const SankeyArtChartSchemaSankeyV1SettingsLabelPlacementEnum = {
    BEFORE: 'before',
    AFTER: 'after',
    INSIDE: 'inside',
    OUTSIDE: 'outside'
} as const;

export type SankeyArtChartSchemaSankeyV1SettingsLabelPlacementEnum = typeof SankeyArtChartSchemaSankeyV1SettingsLabelPlacementEnum[keyof typeof SankeyArtChartSchemaSankeyV1SettingsLabelPlacementEnum];
export const SankeyArtChartSchemaSankeyV1SettingsLabelValueNumberOfDecimalsEnum = {
    ALL: 'all',
    _0: '0',
    _1: '1',
    _2: '2',
    _3: '3'
} as const;

export type SankeyArtChartSchemaSankeyV1SettingsLabelValueNumberOfDecimalsEnum = typeof SankeyArtChartSchemaSankeyV1SettingsLabelValueNumberOfDecimalsEnum[keyof typeof SankeyArtChartSchemaSankeyV1SettingsLabelValueNumberOfDecimalsEnum];
export const SankeyArtChartSchemaSankeyV1SettingsLabelValueTypeEnum = {
    AMOUNT: 'amount',
    PERCENT_NEIGHBOR: 'percent-neighbor',
    PERCENT_HIGHEST: 'percent-highest'
} as const;

export type SankeyArtChartSchemaSankeyV1SettingsLabelValueTypeEnum = typeof SankeyArtChartSchemaSankeyV1SettingsLabelValueTypeEnum[keyof typeof SankeyArtChartSchemaSankeyV1SettingsLabelValueTypeEnum];
export const SankeyArtChartSchemaSankeyV1SettingsStatementTypeEnum = {
    INCOME: 'income',
    CASHFLOW: 'cashflow',
    BALANCE: 'balance',
    BUDGET: 'budget',
    OTHER: 'other'
} as const;

export type SankeyArtChartSchemaSankeyV1SettingsStatementTypeEnum = typeof SankeyArtChartSchemaSankeyV1SettingsStatementTypeEnum[keyof typeof SankeyArtChartSchemaSankeyV1SettingsStatementTypeEnum];

/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1Title
 */
export interface SankeyArtChartSchemaSankeyV1Title {
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1Title
     */
    'color': string;
    /**
     * 
     * @type {number}
     * @memberof SankeyArtChartSchemaSankeyV1Title
     */
    'font_size': number;
    /**
     * 
     * @type {SankeyArtChartSchemaSankeyV1TitleValue}
     * @memberof SankeyArtChartSchemaSankeyV1Title
     */
    'value': SankeyArtChartSchemaSankeyV1TitleValue;
    /**
     * 
     * @type {boolean}
     * @memberof SankeyArtChartSchemaSankeyV1Title
     */
    'visible': boolean;
}
/**
 * 
 * @export
 * @interface SankeyArtChartSchemaSankeyV1TitleValue
 */
export interface SankeyArtChartSchemaSankeyV1TitleValue {
    /**
     * 
     * @type {string}
     * @memberof SankeyArtChartSchemaSankeyV1TitleValue
     */
    'custom': string;
    /**
     * 
     * @type {boolean}
     * @memberof SankeyArtChartSchemaSankeyV1TitleValue
     */
    'use_custom': boolean;
}
/**
 * 
 * @export
 * @interface SankeyGenerationStatusResponse
 */
export interface SankeyGenerationStatusResponse {
    /**
     * The status of the Celery task: PENDING (still running), SUCCESS (completed), or FAILURE (error occurred).  * `PENDING` - PENDING * `SUCCESS` - SUCCESS * `FAILURE` - FAILURE
     * @type {SankeyGenerationStatusResponseStatusEnum}
     * @memberof SankeyGenerationStatusResponse
     */
    'status': SankeyGenerationStatusResponseStatusEnum;
    /**
     * 
     * @type {Sankey}
     * @memberof SankeyGenerationStatusResponse
     */
    'result': Sankey | null;
    /**
     * 
     * @type {string}
     * @memberof SankeyGenerationStatusResponse
     */
    'error': string | null;
}
/**
 * * `PENDING` - PENDING * `SUCCESS` - SUCCESS * `FAILURE` - FAILURE
 * @export
 * @enum {string}
 */

export const SankeyGenerationStatusResponseStatusEnum = {
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
} as const;

export type SankeyGenerationStatusResponseStatusEnum = typeof SankeyGenerationStatusResponseStatusEnum[keyof typeof SankeyGenerationStatusResponseStatusEnum];


/**
 * 
 * @export
 * @interface SankeyRequest
 */
export interface SankeyRequest {
    /**
     * Background color of the diagram.
     * @type {string}
     * @memberof SankeyRequest
     */
    'background_color'?: string;
    /**
     * Canvas height in pixels.
     * @type {number}
     * @memberof SankeyRequest
     */
    'canvas_height'?: number;
    /**
     * The size of the canvas.  * `1` - S * `2` - M * `3` - L * `custom` - Custom size
     * @type {CanvasSizeEnum}
     * @memberof SankeyRequest
     */
    'canvas_size'?: CanvasSizeEnum;
    /**
     * Canvas width in pixels.
     * @type {number}
     * @memberof SankeyRequest
     */
    'canvas_width'?: number;
    /**
     * 
     * @type {PatchedSankeyRequestChart}
     * @memberof SankeyRequest
     */
    'chart'?: PatchedSankeyRequestChart;
    /**
     * Determines the order of the chart type Sankeys, lower numbers are listed first.
     * @type {number}
     * @memberof SankeyRequest
     */
    'chart_type_list_position'?: number;
    /**
     * Chart type name, used e.g. to describe the Sankey in the footer.
     * @type {string}
     * @memberof SankeyRequest
     */
    'chart_type_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SankeyRequest
     */
    'company_name': string;
    /**
     * 
     * @type {string}
     * @memberof SankeyRequest
     */
    'comparison_line_prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof SankeyRequest
     */
    'comparison_line_suffix'?: string | null;
    /**
     * Type of value for the third label line (e.g. percent or absolute difference)  * `percent` - Percentage * `absolute` - Absolute
     * @type {ComparisonLineValueTypeEnum}
     * @memberof SankeyRequest
     */
    'comparison_line_value_type'?: ComparisonLineValueTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SankeyRequest
     */
    'created_at'?: string | null;
    /**
     * The environment where this diagram was first created.  * `excel` - Excel add-in * `powerpoint` - Powerpoint add-in * `web` - Web app
     * @type {CreatedWithEnum}
     * @memberof SankeyRequest
     */
    'created_with'?: CreatedWithEnum;
    /**
     * The custom diagram title.
     * @type {string}
     * @memberof SankeyRequest
     */
    'custom_title'?: string;
    /**
     * The origin of the diagram data.  * `excel` - Data comes from an Excel spreadsheet * `inline` - Data has been entered directly in the diagram editor UI
     * @type {DataOriginEnum}
     * @memberof SankeyRequest
     */
    'data_origin'?: DataOriginEnum;
    /**
     * Description or link to the original source that the diagram data is based on.
     * @type {string}
     * @memberof SankeyRequest
     */
    'data_source_notes'?: string | null;
    /**
     * 
     * @type {PatchedSankeyRequestDownloadImageFormat}
     * @memberof SankeyRequest
     */
    'download_image_format'?: PatchedSankeyRequestDownloadImageFormat | null;
    /**
     * 
     * @type {PatchedSankeyRequestDownloadScalePng}
     * @memberof SankeyRequest
     */
    'download_scale_png'?: PatchedSankeyRequestDownloadScalePng | null;
    /**
     * The income statement\'s fiscal year.
     * @type {number}
     * @memberof SankeyRequest
     */
    'fiscal_year': number;
    /**
     * Font family of the diagram.  * `Inter` - Inter * `JetBrains Mono` - JetBrains Mono * `Lato` - Lato * `Merriweather` - Merriweather * `Montserrat` - Montserrat * `Nunito` - Nunito * `Open Sans` - Open Sans * `Poppins` - Poppins * `Roboto` - Roboto * `Source Code Pro` - Source Code Pro
     * @type {FontFamilyEnum}
     * @memberof SankeyRequest
     */
    'font_family'?: FontFamilyEnum;
    /**
     * Label font size.
     * @type {number}
     * @memberof SankeyRequest
     */
    'font_size'?: number;
    /**
     * Whether the Sankey is listed as a chart type in the footer.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'is_listed_chart_type_in_footer'?: boolean;
    /**
     * Whether the diagram features as the main example that anonymous users will first get to see.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'is_main_example'?: boolean;
    /**
     * Whether the diagram is an official public SankeyArt diagram that is shown in the official list of public companies.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'is_official'?: boolean | null;
    /**
     * Whether the diagram is a template that users can copy to create quicker.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'is_template'?: boolean;
    /**
     * The code that will be interpreted by JavaScript to create the Sankey diagram.
     * @type {string}
     * @memberof SankeyRequest
     */
    'js_input'?: string;
    /**
     * Positions of the node labels.  * `before` - Before the node * `after` - After the node * `outside` - Outside (before node and then after node) * `inside` - Inside (after node and then before node)
     * @type {LabelPosEnum}
     * @memberof SankeyRequest
     */
    'label_pos'?: LabelPosEnum;
    /**
     * Height of nodes.
     * @type {number}
     * @memberof SankeyRequest
     */
    'node_height'?: number;
    /**
     * Spacing between nodes.
     * @type {number}
     * @memberof SankeyRequest
     */
    'node_spacing'?: number;
    /**
     * Width of nodes.
     * @type {number}
     * @memberof SankeyRequest
     */
    'node_width'?: number | null;
    /**
     * 
     * @type {PatchedSankeyRequestNrOfDecimals}
     * @memberof SankeyRequest
     */
    'nr_of_decimals'?: PatchedSankeyRequestNrOfDecimals | null;
    /**
     * Difference between upvotes and downvotes.
     * @type {number}
     * @memberof SankeyRequest
     */
    'points'?: number | null;
    /**
     * The permission level of everyone on the internet for this diagram.  * `no-access` - No access * `view` - View
     * @type {PublicPermissionEnum}
     * @memberof SankeyRequest
     */
    'public_permission'?: PublicPermissionEnum;
    /**
     * Manual movements of sankey diagram nodes.
     * @type {string}
     * @memberof SankeyRequest
     */
    'remembered_node_moves'?: string | null;
    /**
     * The income statement\'s reporting period.  * `january` - January * `february` - February * `march` - March * `april` - April * `may` - May * `june` - June * `july` - July * `august` - August * `september` - September * `october` - October * `november` - November * `december` - December * `Q1` - Q1 * `Q2` - Q2 * `Q3` - Q3 * `Q4` - Q4 * `H1` - H1 * `H2` - H2 * `full_year` - Full Year
     * @type {ReportingPeriodEnum}
     * @memberof SankeyRequest
     */
    'reporting_period': ReportingPeriodEnum;
    /**
     * Type of value for the second label line (e.g. amount or percentage)  * `amount` - Absolute * `percent-neighbor` - % of neighbor * `percent-highest` - % of highest amount
     * @type {SecondLabelLineValueTypeEnum}
     * @memberof SankeyRequest
     */
    'second_label_line_value_type'?: SecondLabelLineValueTypeEnum;
    /**
     * Whether the diagram canvas resolution is shown in the UI.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'show_canvas_resolution'?: boolean | null;
    /**
     * Wheter the Sankey diagram should show a comparison in node labels.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'show_comparison_line'?: boolean | null;
    /**
     * Whether data editor table is shown in the UI.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'show_data_editor'?: boolean | null;
    /**
     * Wheter imbalances of nodes are shown in the UI.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'show_imbalances'?: boolean | null;
    /**
     * Wheter the Sankey diagram should include node labels.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'show_labels'?: boolean | null;
    /**
     * Wheter the Sankey diagram should show its title (e.g. \'Apple 2022 Q4\').
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'show_title'?: boolean | null;
    /**
     * Wheter the Sankey diagram should include a SankeyArt watermark.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'show_watermark'?: boolean | null;
    /**
     * 
     * @type {PatchedSankeyRequestStatementType}
     * @memberof SankeyRequest
     */
    'statement_type'?: PatchedSankeyRequestStatementType | null;
    /**
     * The SVG representation of this Sankey diagram.
     * @type {string}
     * @memberof SankeyRequest
     */
    'svg_representation'?: string | null;
    /**
     * The permission level of non-owner team members for this diagram.  * `no-access` - No access * `view` - View * `edit` - Edit
     * @type {TeamPermissionEnum}
     * @memberof SankeyRequest
     */
    'team_permission'?: TeamPermissionEnum;
    /**
     * Title font color.
     * @type {string}
     * @memberof SankeyRequest
     */
    'title_font_color'?: string | null;
    /**
     * Title font size.
     * @type {number}
     * @memberof SankeyRequest
     */
    'title_font_size'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SankeyRequest
     */
    'unit_prefix'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SankeyRequest
     */
    'unit_suffix'?: string | null;
    /**
     * Wheter a custom (not automatically generated) diagram title is used.
     * @type {boolean}
     * @memberof SankeyRequest
     */
    'use_custom_title'?: boolean | null;
}
/**
 * * `amount` - Absolute * `percent-neighbor` - % of neighbor * `percent-highest` - % of highest amount
 * @export
 * @enum {string}
 */

export const SecondLabelLineValueTypeEnum = {
    AMOUNT: 'amount',
    PERCENT_NEIGHBOR: 'percent-neighbor',
    PERCENT_HIGHEST: 'percent-highest'
} as const;

export type SecondLabelLineValueTypeEnum = typeof SecondLabelLineValueTypeEnum[keyof typeof SecondLabelLineValueTypeEnum];


/**
 * * `excel` - Excel add-in * `powerpoint` - PowerPoint add-in * `web` - Web app * `unknown` - Unknown
 * @export
 * @enum {string}
 */

export const SignedUpViaEnum = {
    EXCEL: 'excel',
    POWERPOINT: 'powerpoint',
    WEB: 'web',
    UNKNOWN: 'unknown'
} as const;

export type SignedUpViaEnum = typeof SignedUpViaEnum[keyof typeof SignedUpViaEnum];


/**
 * 
 * @export
 * @interface SocialLogin
 */
export interface SocialLogin {
    /**
     * 
     * @type {string}
     * @memberof SocialLogin
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLogin
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLogin
     */
    'id_token'?: string;
}
/**
 * 
 * @export
 * @interface SocialLoginRequest
 */
export interface SocialLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequest
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequest
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequest
     */
    'id_token'?: string;
}
/**
 * * `income` - Income statement * `cashflow` - Cash flow statement * `balance` - Balance sheet * `budget` - Budget * `other` - Other
 * @export
 * @enum {string}
 */

export const StatementTypeEnum = {
    INCOME: 'income',
    CASHFLOW: 'cashflow',
    BALANCE: 'balance',
    BUDGET: 'budget',
    OTHER: 'other'
} as const;

export type StatementTypeEnum = typeof StatementTypeEnum[keyof typeof StatementTypeEnum];


/**
 * 
 * @export
 * @interface SubscribeRequest
 */
export interface SubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscribeRequest
     */
    'sessionId': string;
}
/**
 * A serializer for Subscriptions which uses the SubscriptionWrapper object under the hood
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'display_name': string;
    /**
     * Date when the subscription was first created. The date might differ from the created date due to backdating.
     * @type {string}
     * @memberof Subscription
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    'billing_interval': string;
    /**
     * Start of the current period for which the subscription has been invoiced.
     * @type {string}
     * @memberof Subscription
     */
    'current_period_start': string;
    /**
     * End of the current period for which the subscription has been invoiced. At the end of this period, a new invoice will be created.
     * @type {string}
     * @memberof Subscription
     */
    'current_period_end': string;
    /**
     * If the subscription has been canceled with the ``at_period_end`` flag set to true, ``cancel_at_period_end`` on the subscription will be true. You can use this attribute to determine whether a subscription that has a status of active is scheduled to be canceled at the end of the current period.
     * @type {boolean}
     * @memberof Subscription
     */
    'cancel_at_period_end'?: boolean;
    /**
     * The status of this subscription.  * `active` - Active * `canceled` - Canceled * `incomplete` - Incomplete * `incomplete_expired` - Incomplete Expired * `past_due` - Past due * `trialing` - Trialing * `unpaid` - Unpaid
     * @type {SubscriptionStatusEnum}
     * @memberof Subscription
     */
    'status': SubscriptionStatusEnum;
    /**
     * The quantity applied to this subscription. This value will be `null` for multi-plan subscriptions
     * @type {number}
     * @memberof Subscription
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {Array<SubscriptionItem>}
     * @memberof Subscription
     */
    'items': Array<SubscriptionItem>;
}
/**
 * 
 * @export
 * @interface SubscriptionItem
 */
export interface SubscriptionItem {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItem
     */
    'id': string;
    /**
     * 
     * @type {Price}
     * @memberof SubscriptionItem
     */
    'price': Price;
    /**
     * The quantity of the plan to which the customer should be subscribed.
     * @type {number}
     * @memberof SubscriptionItem
     */
    'quantity'?: number | null;
}
/**
 * 
 * @export
 * @interface SubscriptionItemRequest
 */
export interface SubscriptionItemRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionItemRequest
     */
    'id': string;
    /**
     * 
     * @type {PriceRequest}
     * @memberof SubscriptionItemRequest
     */
    'price': PriceRequest;
    /**
     * The quantity of the plan to which the customer should be subscribed.
     * @type {number}
     * @memberof SubscriptionItemRequest
     */
    'quantity'?: number | null;
}
/**
 * A serializer for Subscriptions which uses the SubscriptionWrapper object under the hood
 * @export
 * @interface SubscriptionRequest
 */
export interface SubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRequest
     */
    'display_name': string;
    /**
     * Date when the subscription was first created. The date might differ from the created date due to backdating.
     * @type {string}
     * @memberof SubscriptionRequest
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionRequest
     */
    'billing_interval': string;
    /**
     * Start of the current period for which the subscription has been invoiced.
     * @type {string}
     * @memberof SubscriptionRequest
     */
    'current_period_start': string;
    /**
     * End of the current period for which the subscription has been invoiced. At the end of this period, a new invoice will be created.
     * @type {string}
     * @memberof SubscriptionRequest
     */
    'current_period_end': string;
    /**
     * If the subscription has been canceled with the ``at_period_end`` flag set to true, ``cancel_at_period_end`` on the subscription will be true. You can use this attribute to determine whether a subscription that has a status of active is scheduled to be canceled at the end of the current period.
     * @type {boolean}
     * @memberof SubscriptionRequest
     */
    'cancel_at_period_end'?: boolean;
    /**
     * The status of this subscription.  * `active` - Active * `canceled` - Canceled * `incomplete` - Incomplete * `incomplete_expired` - Incomplete Expired * `past_due` - Past due * `trialing` - Trialing * `unpaid` - Unpaid
     * @type {SubscriptionStatusEnum}
     * @memberof SubscriptionRequest
     */
    'status': SubscriptionStatusEnum;
    /**
     * The quantity applied to this subscription. This value will be `null` for multi-plan subscriptions
     * @type {number}
     * @memberof SubscriptionRequest
     */
    'quantity'?: number | null;
    /**
     * 
     * @type {Array<SubscriptionItemRequest>}
     * @memberof SubscriptionRequest
     */
    'items': Array<SubscriptionItemRequest>;
}
/**
 * * `active` - Active * `canceled` - Canceled * `incomplete` - Incomplete * `incomplete_expired` - Incomplete Expired * `past_due` - Past due * `trialing` - Trialing * `unpaid` - Unpaid
 * @export
 * @enum {string}
 */

export const SubscriptionStatusEnum = {
    ACTIVE: 'active',
    CANCELED: 'canceled',
    INCOMPLETE: 'incomplete',
    INCOMPLETE_EXPIRED: 'incomplete_expired',
    PAST_DUE: 'past_due',
    TRIALING: 'trialing',
    UNPAID: 'unpaid'
} as const;

export type SubscriptionStatusEnum = typeof SubscriptionStatusEnum[keyof typeof SubscriptionStatusEnum];


/**
 * 
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * 
     * @type {number}
     * @memberof Team
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'slug'?: string;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof Team
     */
    'members': Array<Membership>;
    /**
     * 
     * @type {PatchedTeamRequestCountry}
     * @memberof Team
     */
    'country'?: PatchedTeamRequestCountry;
    /**
     * 
     * @type {boolean}
     * @memberof Team
     */
    'is_b2b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Team
     */
    'has_user_completed_team_info'?: boolean;
    /**
     * The platform this team first signed up through  * `excel` - Excel add-in * `powerpoint` - PowerPoint add-in * `web` - Web app * `unknown` - Unknown
     * @type {SignedUpViaEnum}
     * @memberof Team
     */
    'signed_up_via'?: SignedUpViaEnum;
    /**
     * 
     * @type {PatchedTeamRequestDiscoveredUsThrough}
     * @memberof Team
     */
    'discovered_us_through'?: PatchedTeamRequestDiscoveredUsThrough;
    /**
     * A freetext for how the team discovered SankeyArt if its none of the given options.
     * @type {string}
     * @memberof Team
     */
    'discovered_us_note'?: string;
    /**
     * 
     * @type {Array<Invitation>}
     * @memberof Team
     */
    'invitations': Array<Invitation>;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    'dashboard_url': string;
    /**
     * 
     * @type {boolean}
     * @memberof Team
     */
    'is_team_admin': boolean;
    /**
     * 
     * @type {Subscription}
     * @memberof Team
     */
    'subscription': Subscription;
    /**
     * We handle two cases similar as if the user would have an active Stripe subscription:  1) Custom free plan (this plan is free and not handled via Stripe) 2) Custom enterprise plan (payment can be done by invoice and not via normal subscription flow)  This function overwrites the parent SubscriptionModelBase.has_active_subscription function.
     * @type {boolean}
     * @memberof Team
     */
    'has_active_subscription': boolean;
    /**
     * Has a business subscription or is on a custom enterprise plan.
     * @type {boolean}
     * @memberof Team
     */
    'has_business_subscription': boolean;
    /**
     * Used to store team-specific settings
     * @type {{ [key: string]: any; }}
     * @memberof Team
     */
    'settings'?: { [key: string]: any; };
}
/**
 * * `no-access` - No access * `view` - View * `edit` - Edit
 * @export
 * @enum {string}
 */

export const TeamPermissionEnum = {
    NO_ACCESS: 'no-access',
    VIEW: 'view',
    EDIT: 'edit'
} as const;

export type TeamPermissionEnum = typeof TeamPermissionEnum[keyof typeof TeamPermissionEnum];


/**
 * 
 * @export
 * @interface TeamRequest
 */
export interface TeamRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamRequest
     */
    'slug'?: string;
    /**
     * 
     * @type {PatchedTeamRequestCountry}
     * @memberof TeamRequest
     */
    'country'?: PatchedTeamRequestCountry;
    /**
     * 
     * @type {boolean}
     * @memberof TeamRequest
     */
    'is_b2b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeamRequest
     */
    'has_user_completed_team_info'?: boolean;
    /**
     * The platform this team first signed up through  * `excel` - Excel add-in * `powerpoint` - PowerPoint add-in * `web` - Web app * `unknown` - Unknown
     * @type {SignedUpViaEnum}
     * @memberof TeamRequest
     */
    'signed_up_via'?: SignedUpViaEnum;
    /**
     * 
     * @type {PatchedTeamRequestDiscoveredUsThrough}
     * @memberof TeamRequest
     */
    'discovered_us_through'?: PatchedTeamRequestDiscoveredUsThrough;
    /**
     * A freetext for how the team discovered SankeyArt if its none of the given options.
     * @type {string}
     * @memberof TeamRequest
     */
    'discovered_us_note'?: string;
    /**
     * Used to store team-specific settings
     * @type {{ [key: string]: any; }}
     * @memberof TeamRequest
     */
    'settings'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface Tier
 */
export interface Tier {
    /**
     * 
     * @type {number}
     * @memberof Tier
     */
    'up_to'?: number;
    /**
     * 
     * @type {number}
     * @memberof Tier
     */
    'flat_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Tier
     */
    'unit_amount'?: number;
}
/**
 * 
 * @export
 * @interface TierRequest
 */
export interface TierRequest {
    /**
     * 
     * @type {number}
     * @memberof TierRequest
     */
    'up_to'?: number;
    /**
     * 
     * @type {number}
     * @memberof TierRequest
     */
    'flat_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TierRequest
     */
    'unit_amount'?: number;
}
/**
 * * `graduated` - Graduated * `volume` - Volume-based
 * @export
 * @enum {string}
 */

export const TiersModeEnum = {
    GRADUATED: 'graduated',
    VOLUME: 'volume'
} as const;

export type TiersModeEnum = typeof TiersModeEnum[keyof typeof TiersModeEnum];


/**
 * Serializer for Token model.
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'key': string;
}

/**
 * AiApi - axios parameter creator
 * @export
 */
export const AiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint to start an asynchronous task to generate a Sankey diagram draft from a list of PNG image files.
         * @param {'balance' | 'budget' | 'cashflow' | 'income' | 'other'} statementType The type of financial statement to generate a Sankey diagram for.
         * @param {Array<File>} imageFiles A list of PNG image files to be used for generating the diagram.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSankeyFromImages: async (statementType: 'balance' | 'budget' | 'cashflow' | 'income' | 'other', imageFiles: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statementType' is not null or undefined
            assertParamExists('generateSankeyFromImages', 'statementType', statementType)
            // verify required parameter 'imageFiles' is not null or undefined
            assertParamExists('generateSankeyFromImages', 'imageFiles', imageFiles)
            const localVarPath = `/ai/generate-sankey-from-images/{statement_type}/`
                .replace(`{${"statement_type"}}`, encodeURIComponent(String(statementType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (imageFiles) {
                imageFiles.forEach((element) => {
                    localVarFormParams.append('image_files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to poll for the status of a Sankey generation task.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sankeyGenerationStatus: async (taskId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('sankeyGenerationStatus', 'taskId', taskId)
            const localVarPath = `/ai/sankey-generation-status/{task_id}/`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiApi - functional programming interface
 * @export
 */
export const AiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint to start an asynchronous task to generate a Sankey diagram draft from a list of PNG image files.
         * @param {'balance' | 'budget' | 'cashflow' | 'income' | 'other'} statementType The type of financial statement to generate a Sankey diagram for.
         * @param {Array<File>} imageFiles A list of PNG image files to be used for generating the diagram.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSankeyFromImages(statementType: 'balance' | 'budget' | 'cashflow' | 'income' | 'other', imageFiles: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateSankeyFromImagesTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSankeyFromImages(statementType, imageFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to poll for the status of a Sankey generation task.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sankeyGenerationStatus(taskId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SankeyGenerationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sankeyGenerationStatus(taskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AiApi - factory interface
 * @export
 */
export const AiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiApiFp(configuration)
    return {
        /**
         * Endpoint to start an asynchronous task to generate a Sankey diagram draft from a list of PNG image files.
         * @param {AiApiGenerateSankeyFromImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSankeyFromImages(requestParameters: AiApiGenerateSankeyFromImagesRequest, options?: AxiosRequestConfig): AxiosPromise<GenerateSankeyFromImagesTaskResponse> {
            return localVarFp.generateSankeyFromImages(requestParameters.statementType, requestParameters.imageFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to poll for the status of a Sankey generation task.
         * @param {AiApiSankeyGenerationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sankeyGenerationStatus(requestParameters: AiApiSankeyGenerationStatusRequest, options?: AxiosRequestConfig): AxiosPromise<SankeyGenerationStatusResponse> {
            return localVarFp.sankeyGenerationStatus(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generateSankeyFromImages operation in AiApi.
 * @export
 * @interface AiApiGenerateSankeyFromImagesRequest
 */
export interface AiApiGenerateSankeyFromImagesRequest {
    /**
     * The type of financial statement to generate a Sankey diagram for.
     * @type {'balance' | 'budget' | 'cashflow' | 'income' | 'other'}
     * @memberof AiApiGenerateSankeyFromImages
     */
    readonly statementType: 'balance' | 'budget' | 'cashflow' | 'income' | 'other'

    /**
     * A list of PNG image files to be used for generating the diagram.
     * @type {Array<File>}
     * @memberof AiApiGenerateSankeyFromImages
     */
    readonly imageFiles: Array<File>
}

/**
 * Request parameters for sankeyGenerationStatus operation in AiApi.
 * @export
 * @interface AiApiSankeyGenerationStatusRequest
 */
export interface AiApiSankeyGenerationStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AiApiSankeyGenerationStatus
     */
    readonly taskId: string
}

/**
 * AiApi - object-oriented interface
 * @export
 * @class AiApi
 * @extends {BaseAPI}
 */
export class AiApi extends BaseAPI {
    /**
     * Endpoint to start an asynchronous task to generate a Sankey diagram draft from a list of PNG image files.
     * @param {AiApiGenerateSankeyFromImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public generateSankeyFromImages(requestParameters: AiApiGenerateSankeyFromImagesRequest, options?: AxiosRequestConfig) {
        return AiApiFp(this.configuration).generateSankeyFromImages(requestParameters.statementType, requestParameters.imageFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to poll for the status of a Sankey generation task.
     * @param {AiApiSankeyGenerationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiApi
     */
    public sankeyGenerationStatus(requestParameters: AiApiSankeyGenerationStatusRequest, options?: AxiosRequestConfig) {
        return AiApiFp(this.configuration).sankeyGenerationStatus(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiApi - axios parameter creator
 * @export
 */
export const ApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeProductsList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stripe/active-products/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SankeyRequest} sankeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysCreate: async (sankeyRequest: SankeyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sankeyRequest' is not null or undefined
            assertParamExists('apiSankeysCreate', 'sankeyRequest', sankeyRequest)
            const localVarPath = `/api/sankeys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sankeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this sankey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysDestroy: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSankeysDestroy', 'id', id)
            const localVarPath = `/api/sankeys/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isMainExample] 
         * @param {boolean} [isTemplate] 
         * @param {number} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysList: async (isMainExample?: boolean, isTemplate?: boolean, teamId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sankeys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (isMainExample !== undefined) {
                localVarQueryParameter['is_main_example'] = isMainExample;
            }

            if (isTemplate !== undefined) {
                localVarQueryParameter['is_template'] = isTemplate;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this sankey.
         * @param {PatchedSankeyRequest} [patchedSankeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysPartialUpdate: async (id: number, patchedSankeyRequest?: PatchedSankeyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSankeysPartialUpdate', 'id', id)
            const localVarPath = `/api/sankeys/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedSankeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this sankey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSankeysRetrieve', 'id', id)
            const localVarPath = `/api/sankeys/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this sankey.
         * @param {SankeyRequest} sankeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysUpdate: async (id: number, sankeyRequest: SankeyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSankeysUpdate', 'id', id)
            // verify required parameter 'sankeyRequest' is not null or undefined
            assertParamExists('apiSankeysUpdate', 'sankeyRequest', sankeyRequest)
            const localVarPath = `/api/sankeys/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sankeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamSlug 
         * @param {CreateCheckoutRequest} createCheckoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession: async (teamSlug: string, createCheckoutRequest: CreateCheckoutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamSlug' is not null or undefined
            assertParamExists('createCheckoutSession', 'teamSlug', teamSlug)
            // verify required parameter 'createCheckoutRequest' is not null or undefined
            assertParamExists('createCheckoutSession', 'createCheckoutRequest', createCheckoutRequest)
            const localVarPath = `/api/stripe/create-checkout-session/{team_slug}`
                .replace(`{${"team_slug"}}`, encodeURIComponent(String(teamSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCheckoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamSlug 
         * @param {SubscribeRequest} subscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe: async (teamSlug: string, subscribeRequest: SubscribeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamSlug' is not null or undefined
            assertParamExists('subscribe', 'teamSlug', teamSlug)
            // verify required parameter 'subscribeRequest' is not null or undefined
            assertParamExists('subscribe', 'subscribeRequest', subscribeRequest)
            const localVarPath = `/api/stripe/subscribe/{team_slug}`
                .replace(`{${"team_slug"}}`, encodeURIComponent(String(teamSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiApi - functional programming interface
 * @export
 */
export const ApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activeProductsList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActiveProduct>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activeProductsList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SankeyRequest} sankeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSankeysCreate(sankeyRequest: SankeyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sankey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSankeysCreate(sankeyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this sankey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSankeysDestroy(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSankeysDestroy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [isMainExample] 
         * @param {boolean} [isTemplate] 
         * @param {number} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSankeysList(isMainExample?: boolean, isTemplate?: boolean, teamId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sankey>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSankeysList(isMainExample, isTemplate, teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this sankey.
         * @param {PatchedSankeyRequest} [patchedSankeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSankeysPartialUpdate(id: number, patchedSankeyRequest?: PatchedSankeyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sankey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSankeysPartialUpdate(id, patchedSankeyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this sankey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSankeysRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sankey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSankeysRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this sankey.
         * @param {SankeyRequest} sankeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSankeysUpdate(id: number, sankeyRequest: SankeyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sankey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSankeysUpdate(id, sankeyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamSlug 
         * @param {CreateCheckoutRequest} createCheckoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCheckoutSession(teamSlug: string, createCheckoutRequest: CreateCheckoutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCheckoutSession(teamSlug, createCheckoutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamSlug 
         * @param {SubscribeRequest} subscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribe(teamSlug: string, subscribeRequest: SubscribeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribe(teamSlug, subscribeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiApi - factory interface
 * @export
 */
export const ApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeProductsList(options?: AxiosRequestConfig): AxiosPromise<Array<ActiveProduct>> {
            return localVarFp.activeProductsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiApiApiSankeysCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysCreate(requestParameters: ApiApiApiSankeysCreateRequest, options?: AxiosRequestConfig): AxiosPromise<Sankey> {
            return localVarFp.apiSankeysCreate(requestParameters.sankeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiApiApiSankeysDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysDestroy(requestParameters: ApiApiApiSankeysDestroyRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSankeysDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiApiApiSankeysListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysList(requestParameters: ApiApiApiSankeysListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<Sankey>> {
            return localVarFp.apiSankeysList(requestParameters.isMainExample, requestParameters.isTemplate, requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiApiApiSankeysPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysPartialUpdate(requestParameters: ApiApiApiSankeysPartialUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<Sankey> {
            return localVarFp.apiSankeysPartialUpdate(requestParameters.id, requestParameters.patchedSankeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiApiApiSankeysRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysRetrieve(requestParameters: ApiApiApiSankeysRetrieveRequest, options?: AxiosRequestConfig): AxiosPromise<Sankey> {
            return localVarFp.apiSankeysRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiApiApiSankeysUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSankeysUpdate(requestParameters: ApiApiApiSankeysUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<Sankey> {
            return localVarFp.apiSankeysUpdate(requestParameters.id, requestParameters.sankeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiApiCreateCheckoutSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession(requestParameters: ApiApiCreateCheckoutSessionRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createCheckoutSession(requestParameters.teamSlug, requestParameters.createCheckoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApiApiSubscribeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(requestParameters: ApiApiSubscribeRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribe(requestParameters.teamSlug, requestParameters.subscribeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiSankeysCreate operation in ApiApi.
 * @export
 * @interface ApiApiApiSankeysCreateRequest
 */
export interface ApiApiApiSankeysCreateRequest {
    /**
     * 
     * @type {SankeyRequest}
     * @memberof ApiApiApiSankeysCreate
     */
    readonly sankeyRequest: SankeyRequest
}

/**
 * Request parameters for apiSankeysDestroy operation in ApiApi.
 * @export
 * @interface ApiApiApiSankeysDestroyRequest
 */
export interface ApiApiApiSankeysDestroyRequest {
    /**
     * A unique integer value identifying this sankey.
     * @type {number}
     * @memberof ApiApiApiSankeysDestroy
     */
    readonly id: number
}

/**
 * Request parameters for apiSankeysList operation in ApiApi.
 * @export
 * @interface ApiApiApiSankeysListRequest
 */
export interface ApiApiApiSankeysListRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ApiApiApiSankeysList
     */
    readonly isMainExample?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof ApiApiApiSankeysList
     */
    readonly isTemplate?: boolean

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiSankeysList
     */
    readonly teamId?: number
}

/**
 * Request parameters for apiSankeysPartialUpdate operation in ApiApi.
 * @export
 * @interface ApiApiApiSankeysPartialUpdateRequest
 */
export interface ApiApiApiSankeysPartialUpdateRequest {
    /**
     * A unique integer value identifying this sankey.
     * @type {number}
     * @memberof ApiApiApiSankeysPartialUpdate
     */
    readonly id: number

    /**
     * 
     * @type {PatchedSankeyRequest}
     * @memberof ApiApiApiSankeysPartialUpdate
     */
    readonly patchedSankeyRequest?: PatchedSankeyRequest
}

/**
 * Request parameters for apiSankeysRetrieve operation in ApiApi.
 * @export
 * @interface ApiApiApiSankeysRetrieveRequest
 */
export interface ApiApiApiSankeysRetrieveRequest {
    /**
     * A unique integer value identifying this sankey.
     * @type {number}
     * @memberof ApiApiApiSankeysRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for apiSankeysUpdate operation in ApiApi.
 * @export
 * @interface ApiApiApiSankeysUpdateRequest
 */
export interface ApiApiApiSankeysUpdateRequest {
    /**
     * A unique integer value identifying this sankey.
     * @type {number}
     * @memberof ApiApiApiSankeysUpdate
     */
    readonly id: number

    /**
     * 
     * @type {SankeyRequest}
     * @memberof ApiApiApiSankeysUpdate
     */
    readonly sankeyRequest: SankeyRequest
}

/**
 * Request parameters for createCheckoutSession operation in ApiApi.
 * @export
 * @interface ApiApiCreateCheckoutSessionRequest
 */
export interface ApiApiCreateCheckoutSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiCreateCheckoutSession
     */
    readonly teamSlug: string

    /**
     * 
     * @type {CreateCheckoutRequest}
     * @memberof ApiApiCreateCheckoutSession
     */
    readonly createCheckoutRequest: CreateCheckoutRequest
}

/**
 * Request parameters for subscribe operation in ApiApi.
 * @export
 * @interface ApiApiSubscribeRequest
 */
export interface ApiApiSubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiSubscribe
     */
    readonly teamSlug: string

    /**
     * 
     * @type {SubscribeRequest}
     * @memberof ApiApiSubscribe
     */
    readonly subscribeRequest: SubscribeRequest
}

/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
export class ApiApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public activeProductsList(options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).activeProductsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiApiApiSankeysCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSankeysCreate(requestParameters: ApiApiApiSankeysCreateRequest, options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSankeysCreate(requestParameters.sankeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiApiApiSankeysDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSankeysDestroy(requestParameters: ApiApiApiSankeysDestroyRequest, options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSankeysDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiApiApiSankeysListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSankeysList(requestParameters: ApiApiApiSankeysListRequest = {}, options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSankeysList(requestParameters.isMainExample, requestParameters.isTemplate, requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiApiApiSankeysPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSankeysPartialUpdate(requestParameters: ApiApiApiSankeysPartialUpdateRequest, options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSankeysPartialUpdate(requestParameters.id, requestParameters.patchedSankeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiApiApiSankeysRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSankeysRetrieve(requestParameters: ApiApiApiSankeysRetrieveRequest, options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSankeysRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiApiApiSankeysUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiSankeysUpdate(requestParameters: ApiApiApiSankeysUpdateRequest, options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiSankeysUpdate(requestParameters.id, requestParameters.sankeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiApiCreateCheckoutSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public createCheckoutSession(requestParameters: ApiApiCreateCheckoutSessionRequest, options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).createCheckoutSession(requestParameters.teamSlug, requestParameters.createCheckoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ApiApiSubscribeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public subscribe(requestParameters: ApiApiSubscribeRequest, options?: AxiosRequestConfig) {
        return ApiApiFp(this.configuration).subscribe(requestParameters.teamSlug, requestParameters.subscribeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RestAuthApi - axios parameter creator
 * @export
 */
export const RestAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {SocialLoginRequest} [socialLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthGoogleCreate: async (socialLoginRequest?: SocialLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest-auth/google/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object\'s key.
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthLoginCreate: async (loginRequest: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('restAuthLoginCreate', 'loginRequest', loginRequest)
            const localVarPath = `/rest-auth/login/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthLogoutCreate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest-auth/logout/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthLogoutRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest-auth/logout/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {SocialLoginRequest} [socialLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthMicrosoftCreate: async (socialLoginRequest?: SocialLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest-auth/microsoft/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CustomRegisterRequest} customRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthRegistrationCreate: async (customRegisterRequest: CustomRegisterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customRegisterRequest' is not null or undefined
            assertParamExists('restAuthRegistrationCreate', 'customRegisterRequest', customRegisterRequest)
            const localVarPath = `/rest-auth/registration/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {PatchedCustomUserRequest} [patchedCustomUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthUserPartialUpdate: async (patchedCustomUserRequest?: PatchedCustomUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest-auth/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCustomUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthUserRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rest-auth/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {CustomUserRequest} customUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthUserUpdate: async (customUserRequest: CustomUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customUserRequest' is not null or undefined
            assertParamExists('restAuthUserUpdate', 'customUserRequest', customUserRequest)
            const localVarPath = `/rest-auth/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAuthApi - functional programming interface
 * @export
 */
export const RestAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {SocialLoginRequest} [socialLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthGoogleCreate(socialLoginRequest?: SocialLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SocialLogin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthGoogleCreate(socialLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object\'s key.
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthLoginCreate(loginRequest: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthLoginCreate(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthLogoutCreate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestAuthDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthLogoutCreate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthLogoutRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestAuthDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthLogoutRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {SocialLoginRequest} [socialLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthMicrosoftCreate(socialLoginRequest?: SocialLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SocialLogin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthMicrosoftCreate(socialLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CustomRegisterRequest} customRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthRegistrationCreate(customRegisterRequest: CustomRegisterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthRegistrationCreate(customRegisterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {PatchedCustomUserRequest} [patchedCustomUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthUserPartialUpdate(patchedCustomUserRequest?: PatchedCustomUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthUserPartialUpdate(patchedCustomUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthUserRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthUserRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {CustomUserRequest} customUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restAuthUserUpdate(customUserRequest: CustomUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restAuthUserUpdate(customUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RestAuthApi - factory interface
 * @export
 */
export const RestAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAuthApiFp(configuration)
    return {
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {RestAuthApiRestAuthGoogleCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthGoogleCreate(requestParameters: RestAuthApiRestAuthGoogleCreateRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SocialLogin> {
            return localVarFp.restAuthGoogleCreate(requestParameters.socialLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object\'s key.
         * @param {RestAuthApiRestAuthLoginCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthLoginCreate(requestParameters: RestAuthApiRestAuthLoginCreateRequest, options?: AxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.restAuthLoginCreate(requestParameters.loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthLogoutCreate(options?: AxiosRequestConfig): AxiosPromise<RestAuthDetail> {
            return localVarFp.restAuthLogoutCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthLogoutRetrieve(options?: AxiosRequestConfig): AxiosPromise<RestAuthDetail> {
            return localVarFp.restAuthLogoutRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {RestAuthApiRestAuthMicrosoftCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthMicrosoftCreate(requestParameters: RestAuthApiRestAuthMicrosoftCreateRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SocialLogin> {
            return localVarFp.restAuthMicrosoftCreate(requestParameters.socialLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RestAuthApiRestAuthRegistrationCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthRegistrationCreate(requestParameters: RestAuthApiRestAuthRegistrationCreateRequest, options?: AxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.restAuthRegistrationCreate(requestParameters.customRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {RestAuthApiRestAuthUserPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthUserPartialUpdate(requestParameters: RestAuthApiRestAuthUserPartialUpdateRequest = {}, options?: AxiosRequestConfig): AxiosPromise<CustomUser> {
            return localVarFp.restAuthUserPartialUpdate(requestParameters.patchedCustomUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthUserRetrieve(options?: AxiosRequestConfig): AxiosPromise<CustomUser> {
            return localVarFp.restAuthUserRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
         * @param {RestAuthApiRestAuthUserUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restAuthUserUpdate(requestParameters: RestAuthApiRestAuthUserUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<CustomUser> {
            return localVarFp.restAuthUserUpdate(requestParameters.customUserRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for restAuthGoogleCreate operation in RestAuthApi.
 * @export
 * @interface RestAuthApiRestAuthGoogleCreateRequest
 */
export interface RestAuthApiRestAuthGoogleCreateRequest {
    /**
     * 
     * @type {SocialLoginRequest}
     * @memberof RestAuthApiRestAuthGoogleCreate
     */
    readonly socialLoginRequest?: SocialLoginRequest
}

/**
 * Request parameters for restAuthLoginCreate operation in RestAuthApi.
 * @export
 * @interface RestAuthApiRestAuthLoginCreateRequest
 */
export interface RestAuthApiRestAuthLoginCreateRequest {
    /**
     * 
     * @type {LoginRequest}
     * @memberof RestAuthApiRestAuthLoginCreate
     */
    readonly loginRequest: LoginRequest
}

/**
 * Request parameters for restAuthMicrosoftCreate operation in RestAuthApi.
 * @export
 * @interface RestAuthApiRestAuthMicrosoftCreateRequest
 */
export interface RestAuthApiRestAuthMicrosoftCreateRequest {
    /**
     * 
     * @type {SocialLoginRequest}
     * @memberof RestAuthApiRestAuthMicrosoftCreate
     */
    readonly socialLoginRequest?: SocialLoginRequest
}

/**
 * Request parameters for restAuthRegistrationCreate operation in RestAuthApi.
 * @export
 * @interface RestAuthApiRestAuthRegistrationCreateRequest
 */
export interface RestAuthApiRestAuthRegistrationCreateRequest {
    /**
     * 
     * @type {CustomRegisterRequest}
     * @memberof RestAuthApiRestAuthRegistrationCreate
     */
    readonly customRegisterRequest: CustomRegisterRequest
}

/**
 * Request parameters for restAuthUserPartialUpdate operation in RestAuthApi.
 * @export
 * @interface RestAuthApiRestAuthUserPartialUpdateRequest
 */
export interface RestAuthApiRestAuthUserPartialUpdateRequest {
    /**
     * 
     * @type {PatchedCustomUserRequest}
     * @memberof RestAuthApiRestAuthUserPartialUpdate
     */
    readonly patchedCustomUserRequest?: PatchedCustomUserRequest
}

/**
 * Request parameters for restAuthUserUpdate operation in RestAuthApi.
 * @export
 * @interface RestAuthApiRestAuthUserUpdateRequest
 */
export interface RestAuthApiRestAuthUserUpdateRequest {
    /**
     * 
     * @type {CustomUserRequest}
     * @memberof RestAuthApiRestAuthUserUpdate
     */
    readonly customUserRequest: CustomUserRequest
}

/**
 * RestAuthApi - object-oriented interface
 * @export
 * @class RestAuthApi
 * @extends {BaseAPI}
 */
export class RestAuthApi extends BaseAPI {
    /**
     * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
     * @param {RestAuthApiRestAuthGoogleCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthGoogleCreate(requestParameters: RestAuthApiRestAuthGoogleCreateRequest = {}, options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthGoogleCreate(requestParameters.socialLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object\'s key.
     * @param {RestAuthApiRestAuthLoginCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthLoginCreate(requestParameters: RestAuthApiRestAuthLoginCreateRequest, options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthLoginCreate(requestParameters.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthLogoutCreate(options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthLogoutCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthLogoutRetrieve(options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthLogoutRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
     * @param {RestAuthApiRestAuthMicrosoftCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthMicrosoftCreate(requestParameters: RestAuthApiRestAuthMicrosoftCreateRequest = {}, options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthMicrosoftCreate(requestParameters.socialLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RestAuthApiRestAuthRegistrationCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthRegistrationCreate(requestParameters: RestAuthApiRestAuthRegistrationCreateRequest, options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthRegistrationCreate(requestParameters.customRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @param {RestAuthApiRestAuthUserPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthUserPartialUpdate(requestParameters: RestAuthApiRestAuthUserPartialUpdateRequest = {}, options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthUserPartialUpdate(requestParameters.patchedCustomUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthUserRetrieve(options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthUserRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     * @param {RestAuthApiRestAuthUserUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAuthApi
     */
    public restAuthUserUpdate(requestParameters: RestAuthApiRestAuthUserUpdateRequest, options?: AxiosRequestConfig) {
        return RestAuthApiFp(this.configuration).restAuthUserUpdate(requestParameters.customUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TeamsApi - axios parameter creator
 * @export
 */
export const TeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} teamSlug 
         * @param {InvitationRequest} invitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsCreate: async (teamSlug: string, invitationRequest: InvitationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamSlug' is not null or undefined
            assertParamExists('invitationsCreate', 'teamSlug', teamSlug)
            // verify required parameter 'invitationRequest' is not null or undefined
            assertParamExists('invitationsCreate', 'invitationRequest', invitationRequest)
            const localVarPath = `/a/{team_slug}/team/api/invitations/`
                .replace(`{${"team_slug"}}`, encodeURIComponent(String(teamSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this invitation.
         * @param {string} teamSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsDestroy: async (id: string, teamSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsDestroy', 'id', id)
            // verify required parameter 'teamSlug' is not null or undefined
            assertParamExists('invitationsDestroy', 'teamSlug', teamSlug)
            const localVarPath = `/a/{team_slug}/team/api/invitations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"team_slug"}}`, encodeURIComponent(String(teamSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamSlug 
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsList: async (teamSlug: string, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamSlug' is not null or undefined
            assertParamExists('invitationsList', 'teamSlug', teamSlug)
            const localVarPath = `/a/{team_slug}/team/api/invitations/`
                .replace(`{${"team_slug"}}`, encodeURIComponent(String(teamSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this invitation.
         * @param {string} teamSlug 
         * @param {PatchedInvitationRequest} [patchedInvitationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsPartialUpdate: async (id: string, teamSlug: string, patchedInvitationRequest?: PatchedInvitationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsPartialUpdate', 'id', id)
            // verify required parameter 'teamSlug' is not null or undefined
            assertParamExists('invitationsPartialUpdate', 'teamSlug', teamSlug)
            const localVarPath = `/a/{team_slug}/team/api/invitations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"team_slug"}}`, encodeURIComponent(String(teamSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this invitation.
         * @param {string} teamSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsRetrieve: async (id: string, teamSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsRetrieve', 'id', id)
            // verify required parameter 'teamSlug' is not null or undefined
            assertParamExists('invitationsRetrieve', 'teamSlug', teamSlug)
            const localVarPath = `/a/{team_slug}/team/api/invitations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"team_slug"}}`, encodeURIComponent(String(teamSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this invitation.
         * @param {string} teamSlug 
         * @param {InvitationRequest} invitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsUpdate: async (id: string, teamSlug: string, invitationRequest: InvitationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invitationsUpdate', 'id', id)
            // verify required parameter 'teamSlug' is not null or undefined
            assertParamExists('invitationsUpdate', 'teamSlug', teamSlug)
            // verify required parameter 'invitationRequest' is not null or undefined
            assertParamExists('invitationsUpdate', 'invitationRequest', invitationRequest)
            const localVarPath = `/a/{team_slug}/team/api/invitations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"team_slug"}}`, encodeURIComponent(String(teamSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsCreate: async (teamRequest: TeamRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamRequest' is not null or undefined
            assertParamExists('teamsCreate', 'teamRequest', teamRequest)
            const localVarPath = `/teams/api/teams/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsDestroy: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('teamsDestroy', 'id', id)
            const localVarPath = `/teams/api/teams/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsList: async (page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/api/teams/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this team.
         * @param {PatchedTeamRequest} [patchedTeamRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsPartialUpdate: async (id: number, patchedTeamRequest?: PatchedTeamRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('teamsPartialUpdate', 'id', id)
            const localVarPath = `/teams/api/teams/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTeamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('teamsRetrieve', 'id', id)
            const localVarPath = `/teams/api/teams/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this team.
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsUpdate: async (id: number, teamRequest: TeamRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('teamsUpdate', 'id', id)
            // verify required parameter 'teamRequest' is not null or undefined
            assertParamExists('teamsUpdate', 'teamRequest', teamRequest)
            const localVarPath = `/teams/api/teams/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamsApi - functional programming interface
 * @export
 */
export const TeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} teamSlug 
         * @param {InvitationRequest} invitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsCreate(teamSlug: string, invitationRequest: InvitationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsCreate(teamSlug, invitationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this invitation.
         * @param {string} teamSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsDestroy(id: string, teamSlug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsDestroy(id, teamSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamSlug 
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsList(teamSlug: string, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedInvitationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsList(teamSlug, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this invitation.
         * @param {string} teamSlug 
         * @param {PatchedInvitationRequest} [patchedInvitationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsPartialUpdate(id: string, teamSlug: string, patchedInvitationRequest?: PatchedInvitationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsPartialUpdate(id, teamSlug, patchedInvitationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this invitation.
         * @param {string} teamSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsRetrieve(id: string, teamSlug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsRetrieve(id, teamSlug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this invitation.
         * @param {string} teamSlug 
         * @param {InvitationRequest} invitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invitationsUpdate(id: string, teamSlug: string, invitationRequest: InvitationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invitation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsUpdate(id, teamSlug, invitationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsCreate(teamRequest: TeamRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsCreate(teamRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsDestroy(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsDestroy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsList(page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTeamList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsList(page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this team.
         * @param {PatchedTeamRequest} [patchedTeamRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsPartialUpdate(id: number, patchedTeamRequest?: PatchedTeamRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsPartialUpdate(id, patchedTeamRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this team.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this team.
         * @param {TeamRequest} teamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teamsUpdate(id: number, teamRequest: TeamRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teamsUpdate(id, teamRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TeamsApi - factory interface
 * @export
 */
export const TeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamsApiFp(configuration)
    return {
        /**
         * 
         * @param {TeamsApiInvitationsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsCreate(requestParameters: TeamsApiInvitationsCreateRequest, options?: AxiosRequestConfig): AxiosPromise<Invitation> {
            return localVarFp.invitationsCreate(requestParameters.teamSlug, requestParameters.invitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiInvitationsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsDestroy(requestParameters: TeamsApiInvitationsDestroyRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.invitationsDestroy(requestParameters.id, requestParameters.teamSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiInvitationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsList(requestParameters: TeamsApiInvitationsListRequest, options?: AxiosRequestConfig): AxiosPromise<PaginatedInvitationList> {
            return localVarFp.invitationsList(requestParameters.teamSlug, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiInvitationsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsPartialUpdate(requestParameters: TeamsApiInvitationsPartialUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<Invitation> {
            return localVarFp.invitationsPartialUpdate(requestParameters.id, requestParameters.teamSlug, requestParameters.patchedInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiInvitationsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsRetrieve(requestParameters: TeamsApiInvitationsRetrieveRequest, options?: AxiosRequestConfig): AxiosPromise<Invitation> {
            return localVarFp.invitationsRetrieve(requestParameters.id, requestParameters.teamSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiInvitationsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invitationsUpdate(requestParameters: TeamsApiInvitationsUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<Invitation> {
            return localVarFp.invitationsUpdate(requestParameters.id, requestParameters.teamSlug, requestParameters.invitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiTeamsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsCreate(requestParameters: TeamsApiTeamsCreateRequest, options?: AxiosRequestConfig): AxiosPromise<Team> {
            return localVarFp.teamsCreate(requestParameters.teamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiTeamsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsDestroy(requestParameters: TeamsApiTeamsDestroyRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.teamsDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiTeamsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsList(requestParameters: TeamsApiTeamsListRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PaginatedTeamList> {
            return localVarFp.teamsList(requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiTeamsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsPartialUpdate(requestParameters: TeamsApiTeamsPartialUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<Team> {
            return localVarFp.teamsPartialUpdate(requestParameters.id, requestParameters.patchedTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiTeamsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsRetrieve(requestParameters: TeamsApiTeamsRetrieveRequest, options?: AxiosRequestConfig): AxiosPromise<Team> {
            return localVarFp.teamsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamsApiTeamsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teamsUpdate(requestParameters: TeamsApiTeamsUpdateRequest, options?: AxiosRequestConfig): AxiosPromise<Team> {
            return localVarFp.teamsUpdate(requestParameters.id, requestParameters.teamRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for invitationsCreate operation in TeamsApi.
 * @export
 * @interface TeamsApiInvitationsCreateRequest
 */
export interface TeamsApiInvitationsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamsApiInvitationsCreate
     */
    readonly teamSlug: string

    /**
     * 
     * @type {InvitationRequest}
     * @memberof TeamsApiInvitationsCreate
     */
    readonly invitationRequest: InvitationRequest
}

/**
 * Request parameters for invitationsDestroy operation in TeamsApi.
 * @export
 * @interface TeamsApiInvitationsDestroyRequest
 */
export interface TeamsApiInvitationsDestroyRequest {
    /**
     * A UUID string identifying this invitation.
     * @type {string}
     * @memberof TeamsApiInvitationsDestroy
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TeamsApiInvitationsDestroy
     */
    readonly teamSlug: string
}

/**
 * Request parameters for invitationsList operation in TeamsApi.
 * @export
 * @interface TeamsApiInvitationsListRequest
 */
export interface TeamsApiInvitationsListRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamsApiInvitationsList
     */
    readonly teamSlug: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TeamsApiInvitationsList
     */
    readonly page?: number
}

/**
 * Request parameters for invitationsPartialUpdate operation in TeamsApi.
 * @export
 * @interface TeamsApiInvitationsPartialUpdateRequest
 */
export interface TeamsApiInvitationsPartialUpdateRequest {
    /**
     * A UUID string identifying this invitation.
     * @type {string}
     * @memberof TeamsApiInvitationsPartialUpdate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TeamsApiInvitationsPartialUpdate
     */
    readonly teamSlug: string

    /**
     * 
     * @type {PatchedInvitationRequest}
     * @memberof TeamsApiInvitationsPartialUpdate
     */
    readonly patchedInvitationRequest?: PatchedInvitationRequest
}

/**
 * Request parameters for invitationsRetrieve operation in TeamsApi.
 * @export
 * @interface TeamsApiInvitationsRetrieveRequest
 */
export interface TeamsApiInvitationsRetrieveRequest {
    /**
     * A UUID string identifying this invitation.
     * @type {string}
     * @memberof TeamsApiInvitationsRetrieve
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TeamsApiInvitationsRetrieve
     */
    readonly teamSlug: string
}

/**
 * Request parameters for invitationsUpdate operation in TeamsApi.
 * @export
 * @interface TeamsApiInvitationsUpdateRequest
 */
export interface TeamsApiInvitationsUpdateRequest {
    /**
     * A UUID string identifying this invitation.
     * @type {string}
     * @memberof TeamsApiInvitationsUpdate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TeamsApiInvitationsUpdate
     */
    readonly teamSlug: string

    /**
     * 
     * @type {InvitationRequest}
     * @memberof TeamsApiInvitationsUpdate
     */
    readonly invitationRequest: InvitationRequest
}

/**
 * Request parameters for teamsCreate operation in TeamsApi.
 * @export
 * @interface TeamsApiTeamsCreateRequest
 */
export interface TeamsApiTeamsCreateRequest {
    /**
     * 
     * @type {TeamRequest}
     * @memberof TeamsApiTeamsCreate
     */
    readonly teamRequest: TeamRequest
}

/**
 * Request parameters for teamsDestroy operation in TeamsApi.
 * @export
 * @interface TeamsApiTeamsDestroyRequest
 */
export interface TeamsApiTeamsDestroyRequest {
    /**
     * A unique integer value identifying this team.
     * @type {number}
     * @memberof TeamsApiTeamsDestroy
     */
    readonly id: number
}

/**
 * Request parameters for teamsList operation in TeamsApi.
 * @export
 * @interface TeamsApiTeamsListRequest
 */
export interface TeamsApiTeamsListRequest {
    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof TeamsApiTeamsList
     */
    readonly page?: number
}

/**
 * Request parameters for teamsPartialUpdate operation in TeamsApi.
 * @export
 * @interface TeamsApiTeamsPartialUpdateRequest
 */
export interface TeamsApiTeamsPartialUpdateRequest {
    /**
     * A unique integer value identifying this team.
     * @type {number}
     * @memberof TeamsApiTeamsPartialUpdate
     */
    readonly id: number

    /**
     * 
     * @type {PatchedTeamRequest}
     * @memberof TeamsApiTeamsPartialUpdate
     */
    readonly patchedTeamRequest?: PatchedTeamRequest
}

/**
 * Request parameters for teamsRetrieve operation in TeamsApi.
 * @export
 * @interface TeamsApiTeamsRetrieveRequest
 */
export interface TeamsApiTeamsRetrieveRequest {
    /**
     * A unique integer value identifying this team.
     * @type {number}
     * @memberof TeamsApiTeamsRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for teamsUpdate operation in TeamsApi.
 * @export
 * @interface TeamsApiTeamsUpdateRequest
 */
export interface TeamsApiTeamsUpdateRequest {
    /**
     * A unique integer value identifying this team.
     * @type {number}
     * @memberof TeamsApiTeamsUpdate
     */
    readonly id: number

    /**
     * 
     * @type {TeamRequest}
     * @memberof TeamsApiTeamsUpdate
     */
    readonly teamRequest: TeamRequest
}

/**
 * TeamsApi - object-oriented interface
 * @export
 * @class TeamsApi
 * @extends {BaseAPI}
 */
export class TeamsApi extends BaseAPI {
    /**
     * 
     * @param {TeamsApiInvitationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public invitationsCreate(requestParameters: TeamsApiInvitationsCreateRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).invitationsCreate(requestParameters.teamSlug, requestParameters.invitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiInvitationsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public invitationsDestroy(requestParameters: TeamsApiInvitationsDestroyRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).invitationsDestroy(requestParameters.id, requestParameters.teamSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiInvitationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public invitationsList(requestParameters: TeamsApiInvitationsListRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).invitationsList(requestParameters.teamSlug, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiInvitationsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public invitationsPartialUpdate(requestParameters: TeamsApiInvitationsPartialUpdateRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).invitationsPartialUpdate(requestParameters.id, requestParameters.teamSlug, requestParameters.patchedInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiInvitationsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public invitationsRetrieve(requestParameters: TeamsApiInvitationsRetrieveRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).invitationsRetrieve(requestParameters.id, requestParameters.teamSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiInvitationsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public invitationsUpdate(requestParameters: TeamsApiInvitationsUpdateRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).invitationsUpdate(requestParameters.id, requestParameters.teamSlug, requestParameters.invitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiTeamsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public teamsCreate(requestParameters: TeamsApiTeamsCreateRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsCreate(requestParameters.teamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiTeamsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public teamsDestroy(requestParameters: TeamsApiTeamsDestroyRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiTeamsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public teamsList(requestParameters: TeamsApiTeamsListRequest = {}, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsList(requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiTeamsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public teamsPartialUpdate(requestParameters: TeamsApiTeamsPartialUpdateRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsPartialUpdate(requestParameters.id, requestParameters.patchedTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiTeamsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public teamsRetrieve(requestParameters: TeamsApiTeamsRetrieveRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamsApiTeamsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public teamsUpdate(requestParameters: TeamsApiTeamsUpdateRequest, options?: AxiosRequestConfig) {
        return TeamsApiFp(this.configuration).teamsUpdate(requestParameters.id, requestParameters.teamRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UtilsApi - axios parameter creator
 * @export
 */
export const UtilsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint to parse a PDF file into an array of PNG images, each image representing a page.
         * @param {File} pdfFile PDF file to be converted to PNGs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertPdfToPngs: async (pdfFile: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pdfFile' is not null or undefined
            assertParamExists('convertPdfToPngs', 'pdfFile', pdfFile)
            const localVarPath = `/utils/convert-pdf-to-pngs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (pdfFile !== undefined) { 
                localVarFormParams.append('pdf_file', pdfFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download diagram as an image file from the provided diagram data. This is used as a POST endpoint by diagram editor pages - the reason why we accept a whole Sankey body instead of just an ID is because this endpoint is also used by anonymous users whose edited diagram is not yet stored on our server.
         * @param {string} imageFormat 
         * @param {DownloadImageRequestRequest} downloadImageRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImage: async (imageFormat: string, downloadImageRequestRequest: DownloadImageRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFormat' is not null or undefined
            assertParamExists('downloadImage', 'imageFormat', imageFormat)
            // verify required parameter 'downloadImageRequestRequest' is not null or undefined
            assertParamExists('downloadImage', 'downloadImageRequestRequest', downloadImageRequestRequest)
            const localVarPath = `/utils/download-image/{image_format}`
                .replace(`{${"image_format"}}`, encodeURIComponent(String(imageFormat)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadImageRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilsApi - functional programming interface
 * @export
 */
export const UtilsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilsApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint to parse a PDF file into an array of PNG images, each image representing a page.
         * @param {File} pdfFile PDF file to be converted to PNGs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertPdfToPngs(pdfFile: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConvertPDFToPNGsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertPdfToPngs(pdfFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download diagram as an image file from the provided diagram data. This is used as a POST endpoint by diagram editor pages - the reason why we accept a whole Sankey body instead of just an ID is because this endpoint is also used by anonymous users whose edited diagram is not yet stored on our server.
         * @param {string} imageFormat 
         * @param {DownloadImageRequestRequest} downloadImageRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadImage(imageFormat: string, downloadImageRequestRequest: DownloadImageRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadImage(imageFormat, downloadImageRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UtilsApi - factory interface
 * @export
 */
export const UtilsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilsApiFp(configuration)
    return {
        /**
         * Endpoint to parse a PDF file into an array of PNG images, each image representing a page.
         * @param {UtilsApiConvertPdfToPngsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertPdfToPngs(requestParameters: UtilsApiConvertPdfToPngsRequest, options?: AxiosRequestConfig): AxiosPromise<ConvertPDFToPNGsResponse> {
            return localVarFp.convertPdfToPngs(requestParameters.pdfFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Download diagram as an image file from the provided diagram data. This is used as a POST endpoint by diagram editor pages - the reason why we accept a whole Sankey body instead of just an ID is because this endpoint is also used by anonymous users whose edited diagram is not yet stored on our server.
         * @param {UtilsApiDownloadImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImage(requestParameters: UtilsApiDownloadImageRequest, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadImage(requestParameters.imageFormat, requestParameters.downloadImageRequestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for convertPdfToPngs operation in UtilsApi.
 * @export
 * @interface UtilsApiConvertPdfToPngsRequest
 */
export interface UtilsApiConvertPdfToPngsRequest {
    /**
     * PDF file to be converted to PNGs
     * @type {File}
     * @memberof UtilsApiConvertPdfToPngs
     */
    readonly pdfFile: File
}

/**
 * Request parameters for downloadImage operation in UtilsApi.
 * @export
 * @interface UtilsApiDownloadImageRequest
 */
export interface UtilsApiDownloadImageRequest {
    /**
     * 
     * @type {string}
     * @memberof UtilsApiDownloadImage
     */
    readonly imageFormat: string

    /**
     * 
     * @type {DownloadImageRequestRequest}
     * @memberof UtilsApiDownloadImage
     */
    readonly downloadImageRequestRequest: DownloadImageRequestRequest
}

/**
 * UtilsApi - object-oriented interface
 * @export
 * @class UtilsApi
 * @extends {BaseAPI}
 */
export class UtilsApi extends BaseAPI {
    /**
     * Endpoint to parse a PDF file into an array of PNG images, each image representing a page.
     * @param {UtilsApiConvertPdfToPngsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApi
     */
    public convertPdfToPngs(requestParameters: UtilsApiConvertPdfToPngsRequest, options?: AxiosRequestConfig) {
        return UtilsApiFp(this.configuration).convertPdfToPngs(requestParameters.pdfFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download diagram as an image file from the provided diagram data. This is used as a POST endpoint by diagram editor pages - the reason why we accept a whole Sankey body instead of just an ID is because this endpoint is also used by anonymous users whose edited diagram is not yet stored on our server.
     * @param {UtilsApiDownloadImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApi
     */
    public downloadImage(requestParameters: UtilsApiDownloadImageRequest, options?: AxiosRequestConfig) {
        return UtilsApiFp(this.configuration).downloadImage(requestParameters.imageFormat, requestParameters.downloadImageRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


